/**
 * Media Browser / File Manager.
 * Main application page.
 */

/* eslint max-lines: off */
/* eslint max-lines-per-function: off */
/* eslint max-len: ['error', {code: 250, tabWidth: 4, ignoreUrls: true}] */
/* eslint no-use-before-define: off */

'use strict';

var app              = require('mag-app'),
    Panel            = require('mag-component-panel'),
    PanelSet         = require('mag-component-panel-set'),
    LayoutList       = require('mag-component-layout-list'),
    ModalMessage     = require('mag-component-modal'),
    RadioList        = require('mag-component-radio-list'),
    CheckList        = require('mag-component-check-list'),
    ScrollArea       = require('mag-component-scroll-area'),
    Footer           = require('mag-component-footer'),

    keys             = require('stb-keys'),
    Button           = require('stb-component-button'),
    ScrollBar        = require('stb-component-scrollbar'),

    Flicker          = require('spa-component-flicker'),
    dom              = require('spa-dom'),

    appExit          = require('../modules/app.exit'),
    types            = require('../modules/types'),
    actions          = require('../modules/actions'),
    keyboard         = require('../modules/keyboard'),
    previewImage     = require('../modules/preview.image'),
    parser           = require('../modules/parser'),
    searcher         = require('../modules/searcher'),
    breadcrumbs      = require('../modules/breadcrumbs'),
    diagram          = require('../modules/diagram'),
    contextMenuItems = require('../modules/context.menu.items'),

    evalSpace        = require('../modules/utils/eval.space'),
    random           = require('../modules/utils/random'),
    request          = require('../modules/utils/request'),

    page             = new (require('stb-component-page'))({$node: window.pageMain}),

    mediaTypes       = types.media,
    echo             = core.notify,
    fs               = core.plugins.fs,
    ufsJson          = core.plugins.ufsJson,
    upnp             = core.plugins.upnp,
    tag              = dom.tag,
    UPnPMode         = app.environment.UPnPMode,
    defaultListSize  = app.config.defaultListSize,

    listFolder       = [],
    listFile         = [],
    serversFavShares = [],
    filesByType      = {},
    hotKeyActions    = {},
    modals           = {},
    actualSorting    = 'NAME',
    lastContext      = null,

    // "Back" button, global for multiple purposes
    itemBack = [
        {
            items: [
                {className: 'theme-icon theme-icon-back'},
                '..'
            ],
            click: goBack // eslint-disable-line
        }
    ],

    FILE_SUBTYPE = {
        playlistFile:   0,
        playlistStream: 1
    },

    storages,
    searchRequestRe,
    folderListView,
    originFolderListView,
    openMedia,
    playlist,

    // page components
    panelSet,
    mainPanel,
    rightPanel,
    leftPanelMenu,
    mainPanelList,
    contextMenuList,
    filterMenuList,
    headerAmount,
    mainPanelTitle,
    menuFilteringItem,
    listScroll,
    rightInfoPanelScroll,
    filterScroll,
    $inputSearchIcon,
    $inputSearch,
    $inputFolderName,
    $inputShareName,
    $inputSMBShareLogin,
    $inputSMBSharePassword,
    $inputSMBServerLogin,
    $inputSMBServerPassword;


breadcrumbs.addListener('reset', function () {
    folderListView = null;
    breadcrumbs.reset();
});


/**
 * Search/filter procedure.
 *
 * @param {Object[]} data - data to filter
 * @param {string} marker - which property of data unit use for matching
 *
 * @return {Object[]} filtered data
 */
function filterBySearch ( data, marker ) {
    if ( !searcher.searchRequest ) {
        return data;
    }

    if ( !Array.isArray(data) ) {
        return [];
    }

    return data.filter(function ( item ) {
        return searchRequestRe.test(item[marker]);
    });
}


/** Helper function for closing modal window. */
function closeModalWindow () {
    Object.keys(modals).forEach(function ( modal ) {
        modals[modal].hide();
    });

    panelSet.focus();
    app.runtime.isModalShown = false;
    app.runtime.openShareAttempts = 0;
    mainPanel.$node.classList.contains('active') && page.footer.show();
}


/**
 * "Sugar" function-helper for easy footer modifications.
 *
 * @param {Object[]} config - config with footer parameters
 *
 * @return {Footer} instance of footer for chaining
 */
function initFooter ( config ) {
    var data = {middle: []},
        handler;

    if ( config[0].length ) {
        if ( config[0][0] === keys.menu ) {
            if ( config[0][1] ) {
                handler = config[0][1];
            } else {
                handler = function () {
                    modals.actions.show();
                    page.footer.hide();
                };
            }
        } else {
            handler = config[0][1] || function () { /* action*/ };
        }

        data.left = {
            code: config[0][0],
            action: handler
        };
    }

    config[1].forEach(function ( button ) {
        data.middle.push({code: button[0], title: button[1] || '', action: button[2] || function () { /* action */ }});
    });
    page.footer.init(data);

    return page.footer;
}


/**
 * Import playlist to IPTV channels.
 *
 * @param {Object} data - data to import
 * @param {string} name - name of playlist
 */
/*function importPlaylist ( data, name ) {
    var parsed = parser.getFileNameComponents(name);

    core.intent({
        action: 'playlist',
        data: {
            channels: data,
            name:     parsed.name,
            ext:      parsed.extension
        }
    });
}*/


/**
 * Open specified directory.
 *
 * @param {Object} config - set of parameters associated with particular directory
 * @param {Object} specificOpenerConfig - set of specific parameters
 */
mediaTypes.folder.opener = function ( config, specificOpenerConfig ) {
    var uri;

    if ( specificOpenerConfig.type === 'dvd' ) {
        uri = config.path || breadcrumbs.path;
        core.intent({
            action: 'play',
            mime: mediaTypes.fileVideo.mime,
            data: {
                title:    config.name,
                uri:      uri,
                solution: 'extBDDVD'
            },
            events: {}
        }, function ( error, context ) {
            if ( !error ) {
                lastContext = context;
            }
        });
    }
};


/**
 * Set filter text and icon to default state.
 *
 * @return {string} default title
 */
function resetFilter () {
    menuFilteringItem.innerText = gettext('All');
    menuFilteringItem.previousElementSibling.classList.remove('active');

    return gettext('All');
}


/**
 * Group files depend on their types.
 *
 * @param {Object[]} files - files to group
 */
function groupFilesByType ( files ) {
    filesByType = {};

    files.forEach(file => {
        if ( filesByType[file.type] ) {
            filesByType[file.type].push(file);
        } else {
            filesByType[file.type] = [file];
        }
    });
}


/**
 * Sort current data.
 *
 * @param {string} type - sorting type
 *
 * @return {Object[]} sorted list
 */
function contentSort ( type ) {
    var copyListFull = listFolder.concat(listFile),
        listDirs     = listFolder.slice(),
        listFiles    = copyListFull.filter(function ( item ) {
            return item.value.type === 10;
        });

    switch ( type ) {
        case actualSorting = 'NAME':
            listDirs.sort(function ( itemA, itemB ) {
                return itemA.value.name.toLowerCase().localeCompare(itemB.value.name.toLowerCase());
            });

            listFiles.sort(function ( itemA, itemB ) {
                return itemA.value.name.toLowerCase().localeCompare(itemB.value.name.toLowerCase());
            });

            return itemBack.concat(listDirs, listFiles);
        case actualSorting = 'DATE':
            listFiles.sort(function ( itemA, itemB ) {
                return itemA.value.item.lastModified - itemB.value.item.lastModified;
            });

            return itemBack.concat(listFolder, listFiles);
        case actualSorting = 'TYPE':
            listFiles.sort(function ( itemA, itemB ) {
                return itemA.value.item.extension.toLowerCase().localeCompare(itemB.value.item.extension.toLowerCase());
            });

            return itemBack.concat(listFolder, listFiles);
        case actualSorting = 'SIZE':
            listFiles.sort(function ( itemA, itemB ) {
                return itemA.value.item.size - itemB.value.item.size;
            });

            return itemBack.concat(listFolder, listFiles);
    }

    return itemBack.concat(copyListFull);
}


/**
 * Construct appropriate render structure for lists from raw sources.
 *
 * @param {Object} data - raw data
 * @param {number} type - type of data to render
 * @param {Object} [config] - additional config
 *
 * @return {Object[]} array of ready-to-use in LayoutList objects
 */
function constructDataOut ( data, type, config ) {
    var dirs, files, listData;

    if ( type === 1 ) {
        dirs  = filterBySearch(data.dirs, 'name');
        files = filterBySearch(data.files, 'name');
        files = files.map(function ( item ) {
            var key;

            // set item extension; media stream has no extension
            if ( item.path && item.path.indexOf('://') !== -1 ) {
                item.extension = '';
                item.subtype = FILE_SUBTYPE.playlistStream;
            } else if ( item.size === undefined ) {
                item.extension = item.extension || item.path.split('.').pop().toLowerCase();
                item.subtype = FILE_SUBTYPE.playlistFile;
            } else {
                item.extension = item.extension || item.name.split('.').pop().toLowerCase();
            }

            if ( !item.type ) {
                for ( key in mediaTypes ) {
                    if ( mediaTypes[key].extensions && mediaTypes[key].extensions.indexOf(item.extension) !== -1 ) {
                        item.type = mediaTypes[key].id;
                        break;
                    }
                }
            }

            item.mime = types.idToMedia[item.type].mime;

            return item;
        });

        // create queues of files of particular types/separate files by type
        groupFilesByType(files);

        dirs = dirs.map(function ( item ) {
            var className  = 'theme-icon',
                isFavorite = false,
                index;

            for ( index = 0; index < app.storage.favoritesStorage.length; index += 1 ) {
                if ( app.storage.favoritesStorage[index].path === (item.path || breadcrumbs.path + item.name)) {
                    className  = 'theme-icon theme-icon-favorite-active active';
                    isFavorite = true;
                    break;
                }
            }

            return {
                items: [
                    {
                        className: 'theme-icon theme-icon-folder'
                    },
                    {
                        value: item.name,
                        className: 'listDirNameField'
                    },
                    {
                        className: className
                    }
                ],
                value: {
                    name:       item.name,
                    type:       9,
                    isFavorite: isFavorite,
                    item:       item
                },
                click: function () {
                    var path;

                    breadcrumbs.push({
                        index: mainPanelList.$focusItem.index,
                        path:  breadcrumbs.config.isDisplayFavorites && !breadcrumbs.length ? item.path : item.name
                    });

                    path = breadcrumbs.path;

                    if ( breadcrumbs.config.isDisplayNfsShare && breadcrumbs.config.currentDeviceType !== mediaTypes.nfsPermanentShare ) {
                        path = breadcrumbs.path.split('/').slice(3).join('/');
                    }


                    function localReadDir () {
                        fs.readDir(path, function ( error, result ) {
                            if ( !error ) {
                                breadcrumbs.config.currentDirFilesCount = result.dirs.length + result.files.length;
                                renderList(constructDataOut(result, 1), listScroll, {focusIndex: 0});
                                renderDetailsList('1000000', [breadcrumbs.config.currentDirFilesCount + '', null, null, null, null, null, null]);
                                filterAtCurrentOutput(filterMenuList.types);
                            }
                        });
                    }


                    if ( ['VIDEO_TS', 'BDMV', 'video_ts', 'bdmv', 'video_ts.ifo', 'VIDEO_TS.IFO'].indexOf(item.name) === -1 ) {
                        localReadDir();
                    } else {
                        echo({
                            title: gettext('Do you want to play the folder content?'),
                            icon: 'info',
                            type: '',
                            buttons: [
                                {
                                    value: gettext('Cancel'),
                                    click: localReadDir
                                },
                                {
                                    value: gettext('Play'),
                                    click: function () {
                                        mediaTypes.folder.opener(item, {type: 'dvd'});
                                    }
                                }
                            ]
                        });
                    }

                    mainPanelTitle.innerText = item.name;
                    // display information about actual filters
                    menuFilteringItem.innerText = filterMenuList.title.length ? filterMenuList.title.join(', ') : resetFilter();
                }
            };
        });

        files = files.map(function ( item ) {
            var className  = 'theme-icon',
                isFavorite = false,
                iconClass, key, index;

            for ( index = 0; index < app.storage.favoritesStorage.length; index += 1 ) {
                if ( app.storage.favoritesStorage[index].path === (item.path || breadcrumbs.path + item.name) ) {
                    className  = 'theme-icon theme-icon-favorite-active active';
                    isFavorite = true;
                    break;
                }
            }

            for ( key in mediaTypes ) {
                if ( mediaTypes[key].extensions && mediaTypes[key].extensions.indexOf(item.extension) !== -1 ) {
                    iconClass = mediaTypes[key].icon;
                    break;
                }
            }

            return {
                items: [
                    {
                        className: 'theme-icon ' + iconClass + (breadcrumbs.config.type === 1 ? ' listDirFileIcon' : '')
                    },
                    {
                        value: item.name,
                        className: 'listDirNameField'
                    },
                    {
                        className: className
                    }
                ],
                value: {
                    name:       item.name,
                    type:       10,
                    item:       item,
                    isFavorite: isFavorite
                },
                click: function () {
                    if ( types.idToMedia[item.type].opener ) {
                        if ( item.type === mediaTypes.filePlaylist.id ) {
                            breadcrumbs.config.isDisplayPlaylist = true;
                        }

                        types.idToMedia[item.type].opener(item);
                    } else {
                        echo({
                            title: gettext('Can not open this type of file'),
                            icon: 'info'
                        });
                    }
                }
            };
        });
    } else if ( type === mediaTypes.network.id ) {
        data = (data || []).map(function ( item ) {
            var additionalClass = '',
                shareName       = item.name,
                sharesStorage   = app.storage.network.smb,
                shares, index;

            if ( config && config.favSharesPresent ) {
                shares = sharesStorage.slice(config.index);
                for ( index = shares.length; index--; ) {
                    if ( shares[index].name === shareName ) {
                        additionalClass = ' active';
                        break;
                    }
                }
            }

            return {
                items: [
                    {
                        className: 'theme-icon ' + ((config && config.icon) || 'theme-icon-network') + additionalClass
                    },
                    item.name
                ],
                click: function () {
                    if ( app.runtime.stillWaitNetworkResponse ) {
                        return;
                    }

                    app.runtime.stillWaitNetworkResponse = true;

                    if ( breadcrumbs.length === 1 ) {
                        breadcrumbs.push({
                            index: mainPanelList.$focusItem.index,
                            path: {group: item.name, uri: item.uri},
                            type: mediaTypes.smbWorkgroup
                        });

                        smbTraverse('getServers', breadcrumbs.head.path, {icon: 'theme-icon-server'}, function () {
                            mainPanelTitle.innerText = gettext('servers');
                            app.runtime.stillWaitNetworkResponse = false;
                        });
                    } else if ( breadcrumbs.length === 2 ) {
                        breadcrumbs.push({
                            index: mainPanelList.$focusItem.index,
                            path:  app.runtime.currentServer = item.name,
                            type:  mediaTypes.smbServer
                        });

                        smbTraverse('getShares', {server: breadcrumbs.head.path}, {icon: 'theme-icon-shared-folder'}, function () {
                            if ( breadcrumbs.length < 3 ) {
                                breadcrumbs.push({
                                    index: mainPanelList.$focusItem.index,
                                    path:  item.name,
                                    type:  mediaTypes.smbServer
                                });
                            }

                            mainPanelTitle.innerText = 'SAMBA';
                            app.runtime.stillWaitNetworkResponse = false;
                        });
                    } else if ( breadcrumbs.length === 3 ) {
                        smbTraverse('openShare', {addresses: item.addresses, folder: item.name, mountPath: app.config.mountPathSMB}, {}, function () {
                            mainPanelTitle.innerText = item.name;
                            // display information about actual filters
                            menuFilteringItem.innerText = filterMenuList.title.length ? filterMenuList.title.join(', ') : resetFilter();
                            app.runtime.stillWaitNetworkResponse = false;
                        });
                    }
                },
                value: {
                    item: item
                }
            };
        });

        return itemBack.concat(data);
    } else if ( type === mediaTypes.nfsServer ) {
        data = (data || []).map(function ( server ) {
            return {
                items: [
                    {
                        className: 'theme-icon theme-icon-server'
                    },
                    server
                ],
                click: function () {
                    if ( app.runtime.stillWaitNetworkResponse ) {
                        return;
                    }

                    app.runtime.stillWaitNetworkResponse = true;
                    breadcrumbs.push({
                        index: mainPanelList.$focusItem.index,
                        path:  app.runtime.currentServer = server,
                        type:  mediaTypes.nfsShare
                    });
                    nfsTraverse('getShares', {server: breadcrumbs.head.path}, {icon: 'theme-icon-shared-folder'});
                },
                value: {
                    item: server
                }
            };
        });

        return itemBack.concat(data);
    } else if ( type === mediaTypes.nfsShare ) {
        data = (data || []).map(function ( share, index ) {
            return {
                items: [
                    {className: 'theme-icon theme-icon-shared-folder' + (config.favoriteNfsShares.indexOf(index) === -1 ? '' : ' active')},
                    share
                ],
                click: function () {
                    if ( app.runtime.stillWaitNetworkResponse ) {
                        return;
                    }

                    app.runtime.stillWaitNetworkResponse = true;
                    breadcrumbs.push({
                        index: mainPanelList.$focusItem.index,
                        path:  share,
                        type:  mediaTypes.folder.id
                    });
                    nfsTraverse('openShare', {server: breadcrumbs.head.path, folder: share}, {}, function () {
                        app.runtime.stillWaitNetworkResponse = false;
                    });
                },
                value: {
                    item: share
                }
            };
        });

        return itemBack.concat(data);
    } else if ( type === mediaTypes.upnp.id ) {
        data = filterBySearch(data, 'name');

        if ( breadcrumbs.config.stageType === mediaTypes.upnpServer ) {
            listData = data.map(function ( item ) {
                return {
                    items: [
                        {
                            className: 'theme-icon theme-icon-shared-folder'
                        },
                        item.name
                    ],
                    click: function () {
                        breadcrumbs.push({
                            index:    mainPanelList.$focusItem.index,
                            url:      item.url,
                            ID:       item.ID,
                            parentID: item.parentID
                        });

                        upnp.openServer(item.url, function ( error, result ) {
                            if ( !error ) {
                                breadcrumbs.config.stageType = mediaTypes.upnpHost;
                                renderList(constructDataOut(result, mediaTypes.upnp.id), listScroll, {focusIndex: 0});
                            }
                        });
                    },
                    value: item
                };
            });

            return itemBack.concat(listData);
        } else if ( breadcrumbs.config.stageType === mediaTypes.upnpHost || breadcrumbs.config.stageType === mediaTypes.upnpDir ) {
            listData = upnp.prepareUPnPContent(data);

            files = listData
                .filter(function ( item ) {
                    return item.type !== 9;
                })
                .map(function ( item ) {
                    item.mime = types.idToMedia[item.type].mime;

                    return item;
                });

            groupFilesByType(files);

            listData = listData.map(function ( item ) {
                return {
                    items: [
                        {
                            className: 'theme-icon ' + (item.type === 9 ? 'theme-icon-folder' : types.idToMedia[item.type].icon)
                        },
                        {
                            value: item.name,
                            className: 'listDirNameField'
                        },
                        {
                            className: 'theme-icon'
                        }
                    ],
                    value: {
                        name: item.name,
                        type: item.type === 9 ? 9 : 10,
                        item: item
                    },
                    click: function () {
                        if ( item.type === 9 ) {
                            breadcrumbs.push({
                                index:    mainPanelList.$focusItem.index,
                                ID:       item.ID,
                                parentID: item.ParentID
                            });

                            upnp.openContext(item.ID, function ( error, result ) {
                                if ( !error ) {
                                    breadcrumbs.config.stageType = mediaTypes.upnpDir;
                                    renderList(constructDataOut(result, mediaTypes.upnp.id), listScroll, {focusIndex: 0});
                                }
                            });
                        } else if ( types.idToMedia[item.type].opener ) {
                            types.idToMedia[item.type].opener(item);
                        } else {
                            echo({
                                title: gettext('Can not open this type of file'),
                                icon: 'info'
                            });
                        }
                    }
                };
            });

            return itemBack.concat(listData);
        }
    }

    listFolder = dirs;
    listFile   = files;

    folderListView       = contentSort(actualSorting);
    originFolderListView = folderListView.slice();

    return originFolderListView;
}


/**
 * Re-render page on data change/some event.
 *
 * @param {Object[]} data - new initialization data
 * @param {Object} scrollType - scroll element
 * @param {Object} mixin - additional properties
 */
function renderList ( data, scrollType, mixin ) {
    var tmpData = {
        scroll: data.length <= defaultListSize ? null : scrollType,
        size:   defaultListSize,
        data:   data
    };

    if ( mixin ) {
        Object.keys(mixin).forEach(function ( item ) {
            tmpData[item] = mixin[item];
        });
    }

    if ( scrollType ) {
        if ( data.length > defaultListSize ) {
            if ( !mainPanelList.scroller ) {
                mainPanelList.scroller = 1;
                scrollType.init({
                    realSize: data.length
                });
                scrollType.$node.style.display = '';
            }
        } else {
            mainPanelList.scroller = 0;
            scrollType.$node.style.display = 'none';
        }
    }

    mainPanelList.init(tmpData);
    headerAmount.innerHTML = breadcrumbs.config.type ? data.length - 1 : renderFilesListInitial.itemsLength;
}


/**
 * Open CUE file.
 *
 * @param {Object} item - meta-information about specified CUE file.
 */
mediaTypes.fileCUE.opener = function ( item ) {
    var uri = item.path || breadcrumbs.path + item.name;

    fs.readFile(uri, function ( error, result ) {
        var cueData   = parser.parseCue(result),
            extension = cueData.files[0].name.replace(/^[^.]+\./, ''),
            content   = [];

        cueData.files.forEach(function ( file ) {
            file.tracks.forEach(function ( track ) {
                var info = {
                    name:      track.number + '. ' + track.title,
                    type:      track.type === 'AUDIO' ? 6 : 5,
                    extension: extension,
                    time:      track.index[track.index.length - 1] || 0,
                    url:       uri + '/' + file.name
                };

                if ( cueData.files.length > 1 ) {
                    info.file = file.name;
                }

                if ( track.performer !== cueData.performer && track.performer !== undefined ) {
                    info.performer = track.performer;
                }

                content.push(info);
            });
        });

        breadcrumbs.push({
            index: mainPanelList.$focusItem.index,
            path:  mainPanelList.$focusItem.data.value.name
        });

        renderList(constructDataOut({dirs: [], files: content}, 1), listScroll, {focusIndex: 0});
    });
};


/**
 * Open playlist.
 *
 * @param {Object} item - item to open
 */
mediaTypes.filePlaylist.opener = function ( item ) {
    var uri = item.path || breadcrumbs.path + item.name,
        callback = function ( status, result ) {
            playlist = parser.parseM3u(result, breadcrumbs);
            playlist.items = playlist.items.filter(function ( playlistItem ) {
                var key;

                for ( key in mediaTypes ) {
                    if ( mediaTypes[key].extensions && mediaTypes[key].extensions.indexOf(playlistItem.extension || '') !== -1 ) {
                        playlistItem.type = key.id;
                        // if playlistItem has extension - it is a m3u-file; otherwise - m3u-stream
                        playlistItem.subtype = playlistItem.extension ? FILE_SUBTYPE.playlistFile : FILE_SUBTYPE.playlistStream;

                        return true;
                    }
                }

                return false;

            });

            breadcrumbs.push({
                index:             mainPanelList.$focusItem.index,
                path:              mainPanelList.$focusItem.data.value.name,
                isDisplayPlaylist: true
            });
            breadcrumbs.config.currentDirFilesCount = playlist.items.length;
            renderList(constructDataOut({dirs: [], files: playlist.items}, 1), listScroll, {focusIndex: 0});
        };

    breadcrumbs.config.opened = item.name;
    request.ajax(uri.indexOf('file://') ? 'file://' + uri : uri, {
        onload: callback,
        onerror: function () {
            fs.readFile(uri, callback);
        }
    });
};


/**
 * Handler for audio and video content.
 *
 * @param {Object} item - item to play
 * @param {Object} mixin - set of additional properties for mixing with item
 */
openMedia = mediaTypes.fileVideo.opener = mediaTypes.fileAudio.opener = function ( item, mixin ) {
    var uri, intent, objData;

    if ( !item ) {
        return;
    }

    if ( item.path ) {
        uri = item.path;
    } else if ( item.item && item.item.path ) {
        uri = item.item.path;
    } else if ( breadcrumbs.config.type === mediaTypes.network.id ) {
        uri = breadcrumbs.path + item.name;
    } else if ( breadcrumbs.config.isDisplayNfsShare && breadcrumbs.config.currentDeviceType !== mediaTypes.nfsPermanentShare ) {
        uri = breadcrumbs.path.split('/').slice(3).join('/') + item.name;
    } else {
        uri = breadcrumbs.path + item.name;
    }

    openMedia.queue = openMedia.queue || filesByType[item.type];

    objData = {
        action: 'play',
        mime: item.mime || mediaTypes.fileStream.mime,
        data: {
            title:    item.name,
            uri:      uri,
            solution: item.solution || 'auto'
        },
        events: {
            end: function () {
                if ( mainPanelList.$focusItem.index >= openMedia.queue.length ) {
                    intent.close();
                    openMedia.queue = null;

                    return;
                }

                mainPanelList.focusIndex(mainPanelList.$focusItem.index + 1);
                openMedia(mainPanelList.$focusItem.value, {context: lastContext});
            },
            prev: function () {
                mainPanelList.focusIndex(mainPanelList.$focusItem.index - 1);
                openMedia(breadcrumbs.config.stageType === mediaTypes.upnpDir ? mainPanelList.$focusItem.value.item : mainPanelList.$focusItem.value, {context: lastContext});
            },
            next: function () {
                mainPanelList.focusIndex(mainPanelList.$focusItem.index + 1);
                openMedia(breadcrumbs.config.stageType === mediaTypes.upnpDir ? mainPanelList.$focusItem.value.item : mainPanelList.$focusItem.value, {context: lastContext});
            },
            close: function () {
                lastContext = null;
            }
        }
    };

    if ( mixin ) {
        Object.keys(mixin).forEach(function ( property ) {
            objData[property] = mixin[property];
        });
    }

    if ( mainPanelList.$focusItem.index - listFolder.length === 1 ) {
        objData.events.prev = null;
    }

    if ( mainPanelList.$focusItem.index >= openMedia.queue.length ) {
        objData.events.next = null;
    }

    intent = core.intent(objData, function ( error, context ) {
        if ( !error ) {
            lastContext = context;
        }
    });
};


/**
 * Open stream.
 *
 * @param {Object} item - item to open
 */
mediaTypes.fileStream.opener = function ( item ) {
    var imageExtensions = mediaTypes.fileImage.extensions,
        audioExtensions = mediaTypes.fileAudio.extensions,
        videoExtensions = mediaTypes.fileVideo.extensions,
        extension       = (item.path.match(/\.[a-z\d]+$/i) || [])[0],
        itemFields;

    itemFields = item.path.split(' ');

    if ( itemFields.length > 1 ) {
        item.solution = itemFields[0];
        item.path = itemFields[itemFields.length - 1];
    }

    if ( extension ) {
        if ( imageExtensions.indexOf(extension) !== -1 ) {
            item.mime = mediaTypes.fileImage.mime;
        } else if ( audioExtensions.indexOf(extension) !== -1 )  {
            item.mime = mediaTypes.fileAudio.mime;
        } else if ( videoExtensions.indexOf(extension) !== -1 ) {
            item.mime = mediaTypes.fileVideo.mime;
        } else {
            item.mime = mediaTypes.fileStream.mime;
        }
    } else {
        item.mime = mediaTypes.fileStream.mime;
    }

    openMedia(item);
};


/**
 * Handler for images content.
 *
 * @param {Object} item - item to open
 * @param {Object} mixin - set of additional properties for mixing with item
 */
mediaTypes.fileImage.opener = function openImage ( item, mixin ) {
    var uri, queue, next, intent, objData;

    if ( !item ) {
        return;
    }

    uri   = item.path || breadcrumbs.path + item.name;
    queue = filesByType[item.type];

    if ( uri.indexOf('file://') && uri.indexOf('http://') && uri.indexOf('https://') ) {
        uri = 'file://' + uri;
    }

    objData = {
        action: 'play',
        mime: item.mime || mediaTypes.fileImage.mime,
        data: {
            title:           item.name,
            uri:             uri,
            totalCount:      queue.length,
            currentPosition: queue.indexOf(item) + 1
        },
        events: {
            end: function () {
                next = queue.next;

                if ( next === undefined ) {
                    next = queue.next = queue.indexOf(item) + 1;
                } else {
                    next = queue.next = next + 1;
                }

                if ( next === queue.length ) {
                    intent.close();
                    mainPanelList.focusIndex(listFolder.length + next + 1);
                    delete queue.next;

                    return;
                }

                openImage(queue[next], {context: lastContext});
            },
            prev: function ( settings ) {
                next = queue.next;

                if ( settings && settings.random ) {
                    next = random(0, queue.length - 1);
                }

                if ( next === 0 || (!next && queue.length === 1) ) {
                    next = queue.next = queue.length - 1;
                } else if ( next === undefined ) {
                    next = queue.next = queue.indexOf(item) - 1;
                } else {
                    next = queue.next = next - 1;
                }
                openImage(queue[next], {context: lastContext});
            },
            next: function ( settings ) {
                next = queue.next;

                if ( settings && settings.random ) {
                    next = random(0, queue.length - 1);
                }

                if ( next === queue.length - 1 || (!next && queue.length === 1) ) {
                    next = queue.next = 0;
                } else if ( next === undefined ) {
                    next = queue.next = queue.indexOf(item) + 1;
                } else {
                    next = queue.next = next + 1;
                }

                openImage(queue[next], {context: lastContext});
            },
            close: function () {
                mainPanelList.focusIndex(next ? listFolder.length + next + 1 : mainPanelList.$focusItem.index);
            }
        }
    };

    if ( mixin ) {
        Object.keys(mixin).forEach(function ( property ) {
            objData[property] = mixin[property];
        });
    }

    intent = core.intent(objData, function ( error, context ) {
        if ( !error ) {
            lastContext = context;
        }
    });
};


/**
 * Open ISO image file.
 *
 * @param {Object} item - item to open
 */
mediaTypes.fileISO.opener = function ( item ) {
    var uri, queue, next, intent, objData;

    if ( !item ) {
        return;
    }

    uri   = item.path || breadcrumbs.path + item.name;
    queue = filesByType[item.type];

    objData = {
        action: 'play',
        mime: item.mime || mediaTypes.fileISO.mime,
        data: {
            title: item.name,
            uri:   uri
        },
        events: {
            end: function () {
                // var queue = filesByType[item.type];

                next = queue.next;

                if ( next === undefined || next === null ) {
                    next = queue.next = queue.indexOf(item) + 1;
                } else {
                    next = queue.next = next + 1;
                }

                if ( next === queue.length ) {
                    intent.close();
                    mainPanelList.focusIndex(listFolder.length + next + 1);
                    queue.next = null;

                    return;
                }

                openMedia(queue[next], {context: lastContext});
            },
            prev: function () {
                // var queue = filesByType[item.type];

                next = queue.next;

                if ( next === 0 || (!next && queue.length === 1) ) {
                    intent.close();
                    mainPanelList.focusIndex(listFolder.length);
                    queue.next = null;

                    return;
                }
                if ( next === undefined || next === null ) {
                    next = queue.next = queue.indexOf(item) - 1;
                } else {
                    next = queue.next = next - 1;
                }

                openMedia(queue[next], {context: lastContext});
            },
            next: function () {
                // var queue = filesByType[item.type];

                next = queue.next;

                if ( next === queue.length - 1 || (!next && queue.length === 1) ) {
                    intent.close();
                    mainPanelList.focusIndex(listFolder.length + next + 1);
                    queue.next = null;

                    return;
                }
                if ( next === undefined || next === null ) {
                    next = queue.next = queue.indexOf(item) + 1;
                } else {
                    next = queue.next = next + 1;
                }

                openMedia(queue[next], {context: lastContext});
            },
            close: function () {
                mainPanelList.focusIndex(next ? listFolder.length + next + 1 : mainPanelList.$focusItem.index);
            }
        }
    };

    // delete intent events depending on file position in queue,
    // disable "prev" on the first one and "next" on the last
    if ( !queue.indexOf(item) ) {
        delete objData.events.prev;
    }

    if ( queue.indexOf(item) === queue.length - 1 ) {
        delete objData.events.next;
    }

    intent = core.intent(objData, function ( error, context ) {
        if ( !error ) {
            lastContext = context;
        }
    });
};


/**
 * Traversing SMB network resources.
 *
 * @param {string} resource - resource to open
 * @param {Object} data - set of properties for opening shared folders
 * @param {Object} config - additional config for opened resource
 * @param {Function} [callback] - method to invoke with a result of operation
 */
function smbTraverse ( resource, data, config, callback ) {
    var indexToSetFocus = config.index === undefined ? 0 : config.index;

    callback = callback || function () { app.runtime.stillWaitNetworkResponse = false; };

    if ( resource === 'getGroups' ) {
        core.plugins.networkSmb.getGroups(function ( error, result ) {
            if ( result ) {
                renderList(constructDataOut(result, mediaTypes.network.id, config), listScroll, {focusIndex: indexToSetFocus});
                callback();
            } else {
                console.log(error);
                echo({
                    title: gettext('Unable to get work groups list'),
                    icon: 'alert',
                    type: 'warning'
                });
            }

            app.runtime.stillWaitNetworkResponse = false;
        });
    } else if ( resource === 'openShare' ) {
        app.runtime.openShareAttempts += 1;
        fs.umount({path: app.config.mountPathSMB, force: true});

        core.plugins.networkSmb.openShare(data, function ( error, result ) {
            if ( !result && app.activePage === app.pages.connect ) {
                callback(true);

                return;
            }

            if ( (!result && app.runtime.openShareAttempts === 1) || error ) {
                echo({
                    title: gettext('Authorization may be required. Specify login and password?'),
                    icon: 'info',
                    type: '',
                    buttons: [
                        {
                            value: gettext('Cancel'),
                            click: function () {
                                app.runtime.openShareAttempts = 0;
                            }
                        },
                        {
                            value: gettext('Ok'),
                            click: function () {
                                panelSet.blur();
                                modals.sambaAuthorize.show();
                            }
                        }
                    ]
                });
            } else if ( !result && app.runtime.openShareAttempts > 1 ) {
                echo({
                    title: gettext('Credentials are incorrect'),
                    icon: 'alert',
                    type: 'warning'
                });
            } else {
                app.runtime.openShareAttempts = 0;

                if ( breadcrumbs.config.currentDeviceType !== 5 ) {
                    breadcrumbs.push({
                        index: mainPanelList.$focusItem.index,
                        path:  data,
                        type:  mediaTypes.smbShare
                    });
                }

                fs.readDir(data.mountPath, function ( error, dirContent ) {
                    if ( !error ) {
                        breadcrumbs.push({
                            index:  mainPanelList.$focusItem.index,
                            path:   data.mountPath,
                            folder: data.folder
                        });
                        breadcrumbs.config.isDisplaySmbShares = true;
                        breadcrumbs.config.currentDirFilesCount = dirContent.dirs.length + dirContent.files.length;
                        renderList(constructDataOut(dirContent, 1), listScroll, {focusIndex: indexToSetFocus});
                        renderDetailsList('1000000', [breadcrumbs.config.currentDirFilesCount + '', null, null, null, null, null, null]);
                    }
                });
            }

            callback();
        });
    } else if ( resource === 'getShares' ) {
        core.plugins.networkSmb.getShares(data, function ( error, result ) {
            app.runtime.stillWaitNetworkResponse = false;

            if ( error ) {
                breadcrumbs.pop();

                if ( !smbTraverse.cache ) {
                    smbTraverse.cache = {};
                }

                smbTraverse.cache.getShares = {};
                smbTraverse.cache.getShares.config = config;
                smbTraverse.cache.getShares.callback = callback;
                echo({
                    title: gettext('Authorization may be required. Specify login and password?'),
                    icon: 'info',
                    type: '',
                    buttons: [
                        {
                            value: gettext('Cancel')
                        },
                        {
                            value: gettext('Ok'),
                            click: function () {
                                panelSet.blur();
                                modals.authorizeSMBServer.show();
                            }
                        }
                    ]
                });
            } else {
                if ( serversFavShares.indexOf(result[0].server) !== -1 ) {
                    config.favSharesPresent = true;
                    config.index = serversFavShares.indexOf(result[0].server);
                }

                callback();
                renderList(constructDataOut(result, mediaTypes.network.id, config), listScroll, {focusIndex: indexToSetFocus});
            }
        });
    } else {
        core.plugins.networkSmb.getServers(data, function ( error, result ) {
            if ( error ) {
                breadcrumbs.pop();

                smbTraverse('getGroups', null, {icon: 'theme-icon-workgroup', index: mainPanelList.$focusItem.index}, function () {
                    mainPanelTitle.innerText = gettext('work groups');
                    app.runtime.stillWaitNetworkResponse = false;
                });

                return;
            }

            renderList(constructDataOut(result, mediaTypes.network.id, config), listScroll, {focusIndex: indexToSetFocus});
            callback();
        });
    }
}


/**
 * Traversing NFS network resources.
 *
 * @param {string} resource - resource to open
 * @param {Object} [data] - set of properties for opening shared folders
 * @param {Object} config - additional config for opened resource
 * @param {Function} [callback] - method to invoke with a result of operation
 */
function nfsTraverse ( resource, data, config, callback ) {
    var indexToSetFocus = config.index === undefined ? 0 : config.index;

    callback = callback || function () { app.runtime.stillWaitNetworkResponse = false; };

    if ( resource === 'getServers' ) {
        core.plugins.networkNfs.getServers(function ( error, result ) {
            if ( result ) {
                mainPanelTitle.innerText = gettext('servers');
                breadcrumbs.config.type = mediaTypes.nfsServer;
                mainPanel.$node.classList.add('networkView');
                renderList(constructDataOut(result, mediaTypes.nfsServer, config), listScroll, {focusIndex: indexToSetFocus});
            } else {
                console.log(error);
                echo({
                    title: gettext('Unable to get servers list'),
                    icon: 'alert',
                    type: 'warning'
                });
            }

            callback();
        });
    } else if ( resource === 'getShares' ) {
        core.plugins.networkNfs.getShares(data, function ( error, result ) {
            if ( result ) {
                config.favoriteNfsShares = [];
                app.storage.network.nfs.forEach(function ( share ) {
                    var pathParts = share.path.split(':');

                    if ( pathParts[0] === data.server && result.indexOf(pathParts[1]) !== -1 ) {
                        config.favoriteNfsShares.push(result.indexOf(pathParts[1]));
                    }
                });

                mainPanelTitle.innerText = 'NFS';
                breadcrumbs.config.type = mediaTypes.nfsShare;
                renderList(constructDataOut(result, mediaTypes.nfsShare, config), listScroll, {focusIndex: indexToSetFocus});
            } else {
                console.log(error);
                echo({
                    title: gettext('Unable to get folders list'),
                    icon: 'alert',
                    type: 'warning'
                });
            }

            callback();
        });
    } else if ( resource === 'openShare' ) {
        core.plugins.networkNfs.umount(true);
        core.plugins.networkNfs.mount(
            {address: data && data.path ? data.path : app.runtime.currentServer.path + ':' + breadcrumbs.head.path},
            function ( error, result ) { // eslint-disable-line
                if ( !result ) {
                    breadcrumbs.pop();
                    callback(true);

                    return;
                }

                fs.readDir(app.config.mountPathNFS, function ( error, dirContent ) {
                    if ( !error ) {
                        breadcrumbs.push({
                            index: mainPanelList.$focusItem.index,
                            path: app.config.mountPathNFS,
                            folder: data.folder
                        });
                        breadcrumbs.config.isDisplayNfsShare = true;
                        breadcrumbs.config.type = mediaTypes.folder.id;
                        breadcrumbs.config.currentDirFilesCount = dirContent.dirs.length + dirContent.files.length;
                        renderList(constructDataOut(dirContent, 1), listScroll, {focusIndex: indexToSetFocus});
                        renderDetailsList('1000000', [breadcrumbs.config.currentDirFilesCount + '', null, null, null, null, null, null]);
                    }
                });
                callback();
            }
        );
    }
}


/**
 * Construct comprehensive information about network share.
 *
 * @param {Object} share - particular share with information about itself
 */
function constructShareInfo ( share ) {
    var nodes = [
        [
            tag('div', {className: 'title'}, gettext('Display name') + ':'),
            tag('div', {}, share.details.displayName || share.details.name)
        ],
        [
            tag('div', {className: 'title'}, gettext('Original name') + ':'),
            tag('div', {}, share.details.name)
        ],
        [
            tag('div', {className: 'title'}, gettext('Type') + ':'),
            tag('div', {}, share.deviceType === mediaTypes.nfsPermanentShare ? 'NFS' : 'SAMBA')
        ],
        [
            tag('div', {className: 'title'}, gettext('Server') + ':'),
            tag('div', {}, share.details.server)
        ],
        [
            tag('div', {className: 'title'}, gettext('Full path') + ':'),
            tag('div', {}, share.details.address)
        ]
    ];

    diagram.hide();
    page.textArea.$body.innerHTML = '';
    page.textArea.$body.appendChild(dom.fragment.apply(
        null, [].concat.apply([], nodes)
    ));
    page.textArea.show();
    page.textArea.init();
}


/** Construct comprehensive information about Favorites. */
function constructFavoritesInfo () {
    var favorites = app.storage.favoritesStorage;

    diagram.hide();
    page.textArea.$body.innerHTML = '';
    page.textArea.$body.appendChild(dom.fragment(
        tag('div', {className: 'title'}, gettext('Total') + ':'),
        tag('div', {}, String(favorites.length))
    ));
}


/**
 * Construct comprehensive information about CUE files.
 *
 * @param {Object} item - item which info we construct
 */
function constructCueInfo ( item ) {
    var uri = item.path || breadcrumbs.path + item.name;

    fs.readFile(uri, function ( error, result ) {
        var parsedCue = parser.parseCue(result),
            nodes = [
                [
                    tag('div', {className: 'title'}, gettext('Name') + ':'),
                    tag('div', {}, item.name)
                ],
                [
                    tag('div', {className: 'title'}, gettext('Creation date') + ':'),
                    tag('div', {}, new Date(item.lastModified).toLocaleDateString())
                ],
                [
                    tag('div', {className: 'title'}, gettext('Size') + ':'),
                    tag('div', {}, evalSpace(item.size))
                ],
                [
                    tag('div', {className: 'title'}, gettext('Album name') + ':'),
                    tag('div', {}, parsedCue.title)
                ],
                [
                    tag('div', {className: 'title'}, gettext('Performer') + ':'),
                    tag('div', {}, parsedCue.performer)
                ],
                [
                    tag('div', {className: 'title'}, gettext('Genre') + ':'),
                    tag('div', {}, parsedCue.genre)
                ],
                [
                    tag('div', {className: 'title'}, gettext('Comment') + ':'),
                    tag('div', {}, parsedCue.comment)
                ],
                [
                    tag('div', {className: 'title'}, gettext('Source') + ':'),
                    tag('div', {}, parsedCue.files[0] ? parsedCue.files[0].name : '')
                ]
            ];

        nodes = nodes.filter(function ( node ) {
            return node[1].innerText;
        });
        page.textArea.$body.innerHTML = '';
        page.textArea.$body.appendChild(dom.fragment.apply(
            null, [].concat.apply([], nodes)
        ));
        page.textArea.show();
        page.textArea.init();
    });
}


/**
 * Render details list in the right panel accordingly to necessary set.
 *
 * @param {string} mask - necessary set of list items
 * @param {Object[]} data - data to set
 * @param {Object} [config] - config for custom structure
 */
function renderDetailsList ( mask, data, config ) {
    var area     = page.textArea,
        maskLst  = mask.split(''),
        nodes    = [];

    if ( config ) {
        config.nodes.forEach(function ( node ) {
            nodes.push([tag('div', {className: 'title'}, node[0] + ':'), tag('div', {}, node[1])]);
        });

        diagram.hide();
    } else {
        nodes = [
            [tag('div', {className: 'title'}, gettext('Elements') + ':')],
            [tag('div', {className: 'title'}, gettext('Name') + ':')],
            [tag('div', {className: 'title'}, gettext('Creation date') + ':')],
            [tag('div', {className: 'title'}, gettext('Size') + ':')],
            [tag('div', {className: 'title'}, gettext('Free space') + ':')],
            [tag('div', {className: 'title'}, gettext('File system') + ':')],
            [tag('div', {className: 'title'}, gettext('Unsaved changes') + ':')],
            [tag('div', {className: 'title'}, gettext('Address') + ':')]
        ];
        diagram[+maskLst[4] ? 'show' : 'hide']();
    }

    area.$body.innerHTML = '';
    area.$body.appendChild(dom.fragment.apply(null,
        [].concat.apply([], nodes.reduce(function ( items, item, index ) {
            if ( +maskLst[index] ) {
                item.push(tag('div', {}, data[index]));
                items.push(item);
            }

            return items;
        }, []))));
    page.textArea.show();
    page.textArea.init();
}


/** Add some file system object to Favorites list. */
function setFavoritesState () {
    var targetNode   = mainPanelList.$focusItem,
        favoriteItem = folderListView[targetNode.index],
        favoriteObj  = {},
        index        = targetNode.index;

    if ( favoriteItem.value.isFavorite ) {
        // remove item from session storage
        app.storage.favoritesStorage = app.storage.favoritesStorage.filter(function ( item ) {
            return (item.path !== breadcrumbs.path + favoriteItem.value.name) && (item.path !== favoriteItem.value.item.path);
        });
        favoriteItem.items[2].value = '';
        favoriteItem.items[2].className = 'theme-icon';
        favoriteItem.value.isFavorite = false;
    } else {
        // add item to session storage
        favoriteObj.type = favoriteItem.value.type;
        favoriteObj.name = favoriteItem.value.name;

        if ( favoriteItem.value.item.subtype === FILE_SUBTYPE.playlistStream ) {
            favoriteObj.path = favoriteItem.value.item.uri;
        } else if ( favoriteItem.value.item.subtype === FILE_SUBTYPE.playlistFile ) {
            favoriteObj.path = favoriteItem.value.item.path;
            favoriteObj.uri = favoriteItem.value.item.uri;
        } else {
            favoriteObj.path = breadcrumbs.path + favoriteItem.value.name;
            favoriteObj.size = favoriteItem.value.item.size;
            favoriteObj.lastModified = favoriteItem.value.item.lastModified;
        }

        app.storage.favoritesStorage.push(favoriteObj);
        favoriteItem.items[2].value = '';
        favoriteItem.items[2].className += ' theme-icon-favorite-active active';
        favoriteItem.value.isFavorite = true;
    }

    renderList(folderListView.slice(0, index).concat(favoriteItem, folderListView.slice(index + 1)), listScroll, {viewIndex: mainPanelList.viewIndex});
    mainPanelList.focusIndex(index);
}


/** Add network share to the list of permanent shares on the init screen. */
function pinShare () {
    var target = mainPanelList.$focusItem,
        index, sharesCount, itemToAdd;

    if ( breadcrumbs.config.isDisplayNfsShare || breadcrumbs.config.type === mediaTypes.nfsShare ) {
        if ( breadcrumbs.config.type === mediaTypes.nfsShare ) {
            itemToAdd = {
                name: target.data.value.item,
                path: breadcrumbs.head.path + ':' + target.data.value.item
            };
            target.children[0].children[0].classList.add('active');
        } else {
            itemToAdd = {
                name: app.runtime.currentShare.path,
                path: app.runtime.currentServer.path + ':' + app.runtime.currentShare.path
            };
        }

        // prevent multiple additions of identical shares
        for ( index = 0, sharesCount = app.storage.network.nfs.length; index < sharesCount; index += 1 ) {
            if ( app.storage.network.nfs[index].path === itemToAdd.path ) {
                return;
            }
        }

        app.storage.network.nfs.push(itemToAdd);
    } else {
        if ( breadcrumbs.length === 5 && !target.index ) {
            itemToAdd = app.runtime.currentShare.path;
            delete itemToAdd.mountPath;
            itemToAdd.name = itemToAdd.folder;
            delete itemToAdd.folder;
        } else {
            itemToAdd = target.data.value.item;
            target.children[0].children[0].classList.add('active');
        }

        // prevent multiple additions of identical shares
        for ( index = 0, sharesCount = app.storage.network.smb.length; index < sharesCount; index += 1 ) {
            if ( JSON.stringify(app.storage.network.smb[index].addresses) === JSON.stringify(itemToAdd.addresses) && app.storage.network.smb[index].name === itemToAdd.name ) {
                return;
            }
        }

        app.storage.network.smb.push(itemToAdd);
    }
}


/** Remove network share from the list of permanent shares on the init screen. */
function removePermanentShare () {
    var target     = mainPanelList.$focusItem,
        targetData = target.data.value.details,
        targetType = target.data.value.deviceType,
        index      = target.index;

    if ( targetType === mediaTypes.nfsPermanentShare ) {
        app.storage.network.nfs = app.storage.network.nfs.filter(function ( item ) {
            return item.path !== targetData.path;
        });
    } else {
        app.storage.network.smb = app.storage.network.smb.filter(function ( item ) {
            if ( targetData.address ) {
                if ( item.address !== targetData.address ) {
                    return true;
                }

                return item.name !== targetData.name;

            }
            if ( JSON.stringify(item.addresses) !== JSON.stringify(targetData.addresses) ) {
                return true;
            }

            return item.name !== targetData.name;


        });
    }

    renderList(renderFilesListInitial(), listScroll, {focusIndex: renderFilesListInitial.itemsLength === index ? index - 1 : index});
}


/**
 * Render files list on app init or on change set of plugged devices.
 *
 * @return {Object[]} items for rendering
 */
function renderFilesListInitial () {
    var list                   = [],
        permanentSmbSharesList = app.storage.network.smb,
        permanentNfsSharesList = app.storage.network.nfs,
        isNfsEnabled           = core.plugins.networkNfs.hasNfsNativeSupport,
        upnpPath,
        itemsToRender,
        persistentItems;

    storages = {};

    if ( window.top.stbUPnP && window.top.stbUPnP.getServerListSync ) {
        if ( app.environment.UPnPMode !== 'off' ) {
            upnp.setPageSize(defaultListSize);
        }
    } else if ( app.environment.UPnPMode !== 'off' ) {
        upnpPath = '/media/UPnP';
    }

    renderFilesListInitial.itemsToRenderNames = isNfsEnabled ? [gettext('Favorites'), 'SAMBA', 'NFS', 'UPnP'] : [gettext('Favorites'), 'SAMBA', 'UPnP'];

    if ( app.environment.UPnPMode === 'off' ) {
        renderFilesListInitial.itemsToRenderNames.pop();
    }

    mediaTypes.favorite.opener = function () {
        var favorites = app.storage.favoritesStorage;

        favorites = favorites.map(function ( item ) {
            var clone = {},
                key;

            for ( key in item ) {
                clone[key] = item[key];
            }

            return clone;
        });
        breadcrumbs.config.type = 1;
        breadcrumbs.config.isDisplayFavorites = true;
        breadcrumbs.config.entryPointIndex = mainPanelList.$focusItem.index;
        breadcrumbs.config.currentDirFilesCount = app.storage.favoritesStorage.length;
        mainPanelTitle.innerText = gettext('Favorites');
        renderList(
            constructDataOut({
                dirs: favorites.filter(function ( item ) { return item.type === 9; }),
                files: favorites.filter(function ( item ) { return item.type > 9 && !(item.type = undefined); })
            }, 1),
            listScroll,
            {focusIndex: 0}
        );
    };
    mediaTypes.smb.opener = function () {
        if ( app.runtime.stillWaitNetworkResponse ) {
            return;
        }

        app.runtime.stillWaitNetworkResponse = true;
        breadcrumbs.config.type = mediaTypes.network.id;
        smbTraverse('getGroups', null, {icon: 'theme-icon-workgroup'}, function () {
            breadcrumbs.pop();
            breadcrumbs.push({
                index: mainPanelList.$focusItem.index,
                path: 'SAMBA_GROUP'
            });

            mainPanel.$node.classList.add('networkView');
            breadcrumbs.config.entryPointIndex = renderFilesListInitial.itemsToRenderNames.indexOf('SAMBA');
            mainPanelTitle.innerText = gettext('work groups');
        });
    };
    mediaTypes.nfs.opener = function () {
        if ( app.runtime.stillWaitNetworkResponse ) {
            return;
        }

        app.runtime.stillWaitNetworkResponse = true;
        breadcrumbs.pop();
        breadcrumbs.push({
            index: breadcrumbs.config.entryPointIndex = mainPanelList.$focusItem.index,
            path: 'NFS_SERVER'
        });
        nfsTraverse('getServers', null, {icon: 'theme-icon-server'});
    };
    mediaTypes.upnp.opener = function () {
        mainPanelTitle.innerText = gettext('UPnP');
        breadcrumbs.config.currentDevice = null;
        breadcrumbs.config.entryPointIndex = mainPanelList.$focusItem.index;
        breadcrumbs.config.currentDeviceType = mediaTypes.upnp.id;
        breadcrumbs.config.stageType = mediaTypes.upnp.id;

        if ( upnpPath ) {
            breadcrumbs.config.type = 1;
            breadcrumbs.push({
                index: mainPanelList.$focusItem.index,
                path: upnpPath
            });
            fs.readDir(breadcrumbs.path, function ( error, result ) {
                if ( !error ) {
                    breadcrumbs.config.currentDirFilesCount = result.dirs.length + result.files.length;
                    renderList(constructDataOut(result, 1), listScroll, {focusIndex: 0});
                }
            });
        } else {
            breadcrumbs.config.type = mediaTypes.upnp.id;
            upnp.openRoot(null, null, function ( error, result ) {
                if ( error ) {
                    echo({
                        title: gettext(error.message),
                        icon: 'alert',
                        type: 'warning'
                    });
                } else {
                    breadcrumbs.config.stageType = mediaTypes.upnpServer;
                    renderList(constructDataOut(result, mediaTypes.upnp.id), listScroll, {focusIndex: 0});
                }
            });
        }

        initFooter([[], [[keys.f4, gettext('Search'), hotKeyActions[actions.search]]]]).show();
    };

    persistentItems = [
        {
            items: [
                {
                    className: 'theme-icon theme-icon-favorite-active'
                },
                {
                    value: gettext('Favorites'),
                    className: 'persistentMainEntries'
                }
            ],
            value: {
                type: 1
            },
            click: mediaTypes.favorite.opener
        },
        {
            items: [
                {
                    className: 'theme-icon theme-icon-network'
                },
                {
                    value: 'SAMBA',
                    className: 'persistentMainEntries'
                }
            ],
            value: {
                type: mediaTypes.network.id
            },
            click: mediaTypes.smb.opener
        },
        {
            items: [
                {
                    className: 'theme-icon theme-icon-network'
                },
                {
                    value: 'NFS',
                    className: 'persistentMainEntries'
                }
            ],
            value: {
                type: mediaTypes.network.id
            },
            click: mediaTypes.nfs.opener
        },
        {
            items: [
                {
                    className: 'theme-icon theme-icon-upnp'
                },
                'UPnP'
            ],
            value: {
                type: mediaTypes.upnp.id
            },
            click: mediaTypes.upnp.opener
        }
    ];

    !isNfsEnabled && persistentItems.splice(2, 1);
    app.environment.UPnPMode === 'off' && persistentItems.pop();
    fs.getMountPoints().forEach(function ( item ) {
        storages[item.sn] = {};
        list.push({
            items: [
                {
                    className: 'theme-icon theme-icon-usb'
                },
                item.label || item.vendor || item.model
            ],
            value: {
                sizeOverview: evalSpace(item.freeSize) + ' / ' + evalSpace(item.size),
                freeSize:     item.freeSize,
                fullSize:     item.size,
                fsType:       types.fs[item.fsType],
                isReadOnly:   item.isReadOnly,
                deviceType:   8
            },
            click: storages[item.sn].opener = function () {
                breadcrumbs.push({
                    index: mainPanelList.$focusItem.index,
                    path:  item.mountPath
                });

                breadcrumbs.config.isDeviceReadOnly = item.isReadOnly;

                fs.readDir(breadcrumbs.path, function ( error, result ) {
                    if ( result ) {
                        mainPanelTitle.innerText = item.label || item.vendor || item.model;
                        breadcrumbs.config.type = 1;
                        breadcrumbs.config.currentDevice = item;
                        breadcrumbs.config.entryPointIndex = mainPanelList.$focusItem.index;
                        breadcrumbs.config.currentDeviceType = 8;
                        breadcrumbs.config.stageType = 8;

                        breadcrumbs.config.currentDirFilesCount = result.dirs.length + result.files.length;
                        renderDetailsList(
                            '1000100',
                            [
                                breadcrumbs.config.currentDirFilesCount + '',
                                null,
                                null,
                                null,
                                evalSpace(item.freeSize) + ' / ' + evalSpace(item.size),
                                null,
                                null
                            ]
                        );
                        renderList(constructDataOut(result, 1), listScroll, {focusIndex: 0});

                        if ( filterMenuList.types.length ) {
                            filterAtCurrentOutput(filterMenuList.types);
                        }
                    } else {
                        console.log(error);
                        breadcrumbs.pop();
                        echo({
                            title: gettext('USB Flash Drive error/unable to open'),
                            icon: 'info'
                        });
                    }

                });
            }
        });

        renderFilesListInitial.itemsToRenderNames.push(item.label || item.vendor || item.model);
    });

    permanentSmbSharesList.forEach(function ( item ) {
        list.push({
            items: [
                {
                    className: 'theme-icon theme-icon-shared-folder'
                },
                item.displayName || item.name
            ],
            value: {
                details: item,
                deviceType: 5
            },
            click: function () {
                if ( app.runtime.stillWaitNetworkResponse ) {
                    return;
                }

                app.runtime.stillWaitNetworkResponse = true;
                breadcrumbs.config.isDisplaySmbShares = true;
                breadcrumbs.config.type = 1;
                breadcrumbs.config.currentDevice = item;
                breadcrumbs.config.currentDeviceType = 5;
                breadcrumbs.config.entryPointIndex = mainPanelList.$focusItem.index;
                smbTraverse('openShare', {
                    addresses: item.addresses,
                    folder: item.name,
                    mountPath: app.config.mountPathSMB,
                    login: item.login,
                    password: item.password
                }, {}, function () {
                    mainPanelTitle.innerText = item.displayName || item.name;
                    app.runtime.stillWaitNetworkResponse = false;
                });
            }
        });

        renderFilesListInitial.itemsToRenderNames.push(item.name);
    });

    permanentNfsSharesList.forEach(function ( share ) {
        var details = share;

        if ( share.displayName ) {
            details.displayName = share.displayName;
        }

        details.server = share.path.replace(/^\D+/, '').replace(/:\/.*$/, '');
        details.address = share.path;
        list.push({
            items: [
                {
                    className: 'theme-icon theme-icon-shared-folder'
                },
                share.displayName || share.name
            ],
            value: {
                details: details,
                deviceType: mediaTypes.nfsPermanentShare
            },
            click: function () {
                if ( app.runtime.stillWaitNetworkResponse ) {
                    return;
                }

                app.runtime.stillWaitNetworkResponse = true;
                breadcrumbs.config.type = mediaTypes.folder.id;
                breadcrumbs.config.currentDevice = share;
                breadcrumbs.config.currentDeviceType = mediaTypes.nfsPermanentShare;
                breadcrumbs.config.entryPointIndex = mainPanelList.$focusItem.index;
                nfsTraverse('openShare', {path: share.path, folder: share.name}, {}, function () {
                    mainPanelTitle.innerText = share.displayName || share.name;
                    page.footer.init();
                    app.runtime.stillWaitNetworkResponse = false;
                });
            }
        });

        renderFilesListInitial.itemsToRenderNames.push(share.name);
    });

    itemsToRender = persistentItems.concat(list);
    renderFilesListInitial.itemsLength = itemsToRender.length;
    renderFilesListInitial.itemsToRender = itemsToRender;
    renderFilesListInitial.currentStdout = itemsToRender.slice();

    return itemsToRender;
}


/**
 * Rename network share in the list of permanent shares on the init screen.
 *
 * @param {string} valueToSet - new name for permanent share
 */
function renamePinnedShare ( valueToSet ) {
    var target     = mainPanelList.$focusItem,
        targetData = target.data.value.details,
        targetType = target.data.value.deviceType,
        isNFS      = targetType === mediaTypes.nfsPermanentShare,
        index      = isNFS ? app.storage.network.nfs.length : app.storage.network.smb.length,
        entry;

    while ( index-- ) {
        entry = app.storage.network[isNFS ? 'nfs' : 'smb'][index];

        if (
            JSON.stringify(isNFS ? entry.path : entry.addresses) === JSON.stringify(isNFS ? targetData.path : targetData.addresses) &&
            entry.name === targetData.name
        ) {
            app.storage.network[isNFS ? 'nfs' : 'smb'][index].displayName = valueToSet;
            break;
        }
    }

    renderList(renderFilesListInitial(), listScroll, {focusIndex: target.index});
}


/** Search at current output by given string. */
function searchAtCurrentOutput () {
    if ( !breadcrumbs.config.type ) {
        searcher.search(
            renderFilesListInitial.itemsToRender,
            function ( item ) {
                return typeof item.items[1] === 'string' ? item.items[1] : item.items[1].value;
            },
            function ( data ) {
                renderFilesListInitial.currentStdout = data;
                renderList(renderFilesListInitial.currentStdout, listScroll, {focusIndex: 0});
                $inputSearchIcon.classList.add('active');

                if ( !renderFilesListInitial.currentStdout.length ) {
                    renderDetailsList('0000000', [null, null, null, null, null, null, null]);
                }

                if ( !searcher.searchRequest ) {
                    $inputSearchIcon.classList.remove('active');
                }

                headerAmount.innerHTML = renderFilesListInitial.currentStdout.length;
                app.runtime.isSearched = true;
            }
        );
    }

    if ( searcher.searchRequest ) {
        app.runtime.isSearched = true;
    } else {
        app.runtime.isSearched = false;
        $inputSearch.innerText = gettext('Search');
        $inputSearchIcon.classList.remove('active');
    }
}


/**
 * Filter by types for current output.
 *
 * @param {Object[]} filterTypes - selected types for filtering
 * @param {string} [navigationDirection] - navigation direction
 */
function filterAtCurrentOutput ( filterTypes, navigationDirection ) {
    var back, currentFilesRawSet, filtered;

    if ( !folderListView ) {
        if ( breadcrumbs.config.type === mediaTypes.upnp.id ) {
            menuFilteringItem.previousElementSibling.classList.add('active');
        }

        return;
    }

    back = [originFolderListView[0]];

    if ( filterTypes.length ) {
        filtered = originFolderListView.slice(1).filter(function ( item ) {
            return filterTypes.indexOf(+item.value.type) !== -1 || filterTypes.indexOf(+item.value.item.type) !== -1;
        });

        currentFilesRawSet = filtered.map(function ( item ) {
            return item.value.item;
        });

        folderListView = back.concat(filtered);
        renderList(folderListView, listScroll, {focusIndex: 0});
        // update files list with currently sorted (for valid files queue in player)
        groupFilesByType(currentFilesRawSet);
        breadcrumbs.config.currentDirFilesCount = filtered.length;
        renderDetailsList('1000000', [breadcrumbs.config.currentDirFilesCount + '', null, null, null, null, null, null]);
        menuFilteringItem.previousElementSibling.classList.add('active');
    } else {
        searchAtCurrentOutput(navigationDirection);
    }
}


/** Delete file objects. */
function removeFileSystemObject () {
    var target = mainPanelList.$focusItem,
        length = folderListView.length,
        index  = target.index;

    fs[target.value.type === 9 ? 'removeDir' : 'removeFile'](breadcrumbs.path + mainPanelList.$focusItem.value.name, function ( error, result ) {
        if ( !error && result ) {
            renderList((folderListView.splice(index, 1), folderListView), listScroll, {focusIndex: length - 1 === index ? index - 1 : index});
        }

        modals.actions.hide();
    });

    breadcrumbs.config.currentDirFilesCount -= 1;
}


/**
 * Render whole page (all panels + auxiliary nodes).
 *
 * @param {Object[]} data - array of structured items for using in LayoutLists
 */
// eslint-disable-next-line
function renderPage ( data ) {
    var menuSortingItem, filterItems,
        buttonCreate, buttonRename, buttonSmbShareAuthorize, buttonSmbServerAuthorize,
        smbAuthorizeModalList, createDirList, renameShareList, authorizeSmbServerList, modalMessageActionsShow;

    hotKeyActions[actions.resetFilters] = () => {
        $inputSearch.innerText = gettext('Search');
        $inputSearchIcon.classList.remove('active');

        // reset filters
        filterItems = filterItems.map(function ( item ) {
            item.state = false;

            return item;
        });

        filterMenuList.setData({data: filterItems});
        searcher.searchRequest = '';
        searchRequestRe = undefined;
        filterAtCurrentOutput([]);
        filterMenuList.types = [];
        filterMenuList.title = [];
        renderFilesListInitial.currentStdout = renderFilesListInitial.itemsToRender.slice();
        resetFilter();

        if ( !breadcrumbs.config.type ) {
            renderList(renderFilesListInitial.currentStdout, listScroll, {focusIndex: 0});
        }

        app.runtime.isSearched = false;
    };

    hotKeyActions[actions.search] = () => {
        keyboard.open({
            title: gettext('FILE SEARCH'),
            value: searcher.searchRequest
        }, function ( event ) {
            if ( !event.value && !app.runtime.isSearched ) {
                return;
            }

            $inputSearch.innerText = event.value || gettext('Search');

            searcher.searchRequest = event.value;
            searchRequestRe = new RegExp(searcher.searchRequest, 'i');
            searchAtCurrentOutput();
        });
    };

    hotKeyActions[actions.createFolder] = () => {
        modals.actions.hide();
        panelSet.blur();
        modals.createFolder.show();
        modals.createFolder.focus();
        createDirList.focus();
        createDirList.focusIndex(0);
    };

    hotKeyActions[actions.deleteFile] = () => {
        echo({
            title: gettext('Are you sure you want to delete this item?'),
            icon: 'info',
            type: '',
            buttons: [
                {
                    value: gettext('Cancel')
                },
                {
                    value: gettext('Ok'),
                    click: removeFileSystemObject
                }
            ]

        });
    };

    hotKeyActions[actions.pinShare] = pinShare;

    hotKeyActions[actions.renamePinnedShare] = () => {
        modals.actions.hide();
        panelSet.blur();
        modals.renameShare.show();
        modals.renameShare.focus();
        renameShareList.focus();
        renameShareList.focusIndex(0);
    };

    hotKeyActions[actions.unpinShare] = () => {
        echo({
            title: gettext('Are you sure you want to delete this shared folder?'),
            icon: 'info',
            type: '',
            buttons: [
                {
                    value: gettext('Cancel')
                },
                {
                    value: gettext('Ok'),
                    click: function () {
                        removePermanentShare();
                        modals.actions.hide();
                        page.footer.show();
                    }
                }
            ]

        });
    };

    hotKeyActions[actions.setFavoritesState] = setFavoritesState;

    hotKeyActions[actions.clearFavorites] = () => {
        echo({
            title: gettext('Are you sure you want to clear the list of favorites?'),
            icon: 'info',
            type: '',
            buttons: [
                {
                    value: gettext('Cancel')
                },
                {
                    value: gettext('Ok'),
                    click: function () {
                        app.storage.favoritesStorage = [];
                    }
                }
            ]
        });
    };

    hotKeyActions[actions.clearSmbCache] = () => {
        core.plugins.networkSmb.clearCache();

        if ( app.runtime.stillWaitNetworkResponse ) {
            return;
        }

        if ( breadcrumbs.length === 1 ) {
            smbTraverse('getGroups', null, {icon: 'theme-icon-workgroup'});
        } else if ( breadcrumbs.length === 2 ) {
            smbTraverse('getServers', breadcrumbs.head.path, {icon: 'theme-icon-server'});
        } else if ( breadcrumbs.length === 3 ) {
            smbTraverse('getShares', {server: breadcrumbs.head.path}, {icon: 'theme-icon-shared-folder'});
        }

        app.runtime.stillWaitNetworkResponse = true;
    };

    hotKeyActions[actions.clearNfsCache] = () => {
        core.plugins.networkNfs.clearCache();

        if ( app.runtime.stillWaitNetworkResponse ) {
            return;
        }

        if ( breadcrumbs.config.type === mediaTypes.nfsServer ) {
            nfsTraverse('getServers', null, {icon: 'theme-icon-server'});
        } else if ( breadcrumbs.config.type === mediaTypes.nfsShare ) {
            nfsTraverse('getShares', {server: breadcrumbs.head.path}, {icon: 'theme-icon-shared-folder'});
        }

        app.runtime.stillWaitNetworkResponse = true;
    };

    Object.keys(actions).forEach(action => {
        contextMenuItems[action].click = hotKeyActions[actions[action]];
    });

    filterItems = [
        {state: false, title: gettext('Folders'), value: mediaTypes.folder.id},
        {state: false, title: gettext('Video'), value: mediaTypes.fileVideo.id},
        {state: false, title: gettext('Audio'), value: mediaTypes.fileAudio.id},
        {state: false, title: gettext('Images'), value: mediaTypes.fileImage.id},
        {state: false, title: gettext('Text'), value: mediaTypes.fileText.id},
        {state: false, title: gettext('CUE'), value: mediaTypes.fileCUE.id},
        {state: false, title: gettext('Disk images'), value: mediaTypes.fileISO.id},
        {state: false, title: gettext('Playlists'), value: mediaTypes.filePlaylist.id},
        {state: false, title: gettext('Streams'), value: mediaTypes.fileStream.id}
    ];

    page.footer = new Footer({
        parent: page,
        data: []
    });

    listScroll = new ScrollBar({
        value: 0,
        viewSize: defaultListSize,
        className: 'listScroll'
    });

    filterScroll = new ScrollBar({
        value: 0,
        viewSize: 5,
        className: 'filterScroll'
    });

    rightInfoPanelScroll = new ScrollBar({className: 'rightInfoPanelScroll'});

    page.textArea = new ScrollArea({propagate: true, scroll: rightInfoPanelScroll, step: 1});

    buttonCreate = new Button({
        value: gettext('create'),
        className: 'buttonCreateRename bottom'
    });

    buttonRename = new Button({
        value: gettext('Rename'),
        className: 'buttonCreateRename bottom'
    });

    buttonSmbShareAuthorize = new Button({
        value: gettext('authorize'),
        className: 'buttonAuthorize bottom'
    });

    buttonSmbServerAuthorize = new Button({
        value: gettext('authorize'),
        className: 'buttonAuthorize bottom'
    });

    modals.authorizeSMBServer = new ModalMessage({
        title: gettext('authorization'),
        events: {
            show: function () {
                app.runtime.isModalShown = true;
                page.footer.hide();
                modals.authorizeSMBServer.focus();
            },
            hide: function () {
                authorizeSmbServerList.loginAttempt = authorizeSmbServerList.passwordAttempt = false;
                closeModalWindow();
            }
        },
        children: [
            authorizeSmbServerList = new LayoutList({
                className: 'padded',
                cycle: true,
                size: 2,
                focusIndex: 0,
                data: [
                    {
                        items: [
                            $inputSMBServerLogin = tag(
                                'div',
                                {className: 'inputSMBShareLoginField theme-item-editable disabled'},
                                gettext('Login')
                            )
                        ],
                        click: function () {
                            keyboard.open({
                                title: gettext('ENTER LOGIN'),
                                value: authorizeSmbServerList.loginAttempt ? $inputSMBServerLogin.innerText : ''
                            }, function ( event ) {
                                $inputSMBServerLogin.innerText = event.value || gettext('Login');
                                authorizeSmbServerList.loginAttempt = !!event.value;
                            });
                        }
                    },
                    {
                        items: [
                            $inputSMBServerPassword = tag('div', {className: 'inputSMBSharePasswdField'}, gettext('Password')),
                            {
                                className: 'theme-item-editable disabled'
                            }
                        ],
                        click: function () {
                            keyboard.open({
                                title: gettext('ENTER PASSWORD'),
                                value: authorizeSmbServerList.passwordAttempt ? $inputSMBServerPassword.innerText : '',
                                type: 'password'
                            }, function ( event ) {
                                event.value = event.value.trim();
                                authorizeSmbServerList.passwordAttempt = !!event.value;

                                if ( event.value ) {
                                    $inputSMBServerPassword.password = event.value;
                                    $inputSMBServerPassword.innerText = event.value;
                                    $inputSMBServerPassword.classList.add('theme-text-password');
                                } else {
                                    $inputSMBServerPassword.classList.remove('theme-text-password');
                                    $inputSMBServerPassword.innerText = gettext('Password');
                                }
                            });
                        }
                    }
                ],
                events: {
                    overflow: function ( event ) {
                        if ( event.direction === keys.down || event.direction === keys.up ) {
                            this.blurItem(this.$focusItem);
                            buttonSmbServerAuthorize.focus();
                        }
                    }
                }
            }),
            buttonSmbServerAuthorize
        ]
    });

    modals.sambaAuthorize = new ModalMessage({
        title: gettext('authorization'),
        events: {
            show: function () {
                app.runtime.isModalShown = true;
                page.footer.hide();
                modals.sambaAuthorize.focus();
            },
            hide: function () {
                smbAuthorizeModalList.loginAttempt = smbAuthorizeModalList.passwordAttempt = false;
                closeModalWindow();
            }
        },
        children: [
            smbAuthorizeModalList = new LayoutList({
                className: 'padded',
                cycle: true,
                size: 2,
                focusIndex: 0,
                data: [
                    {
                        items: [
                            $inputSMBShareLogin = tag(
                                'div',
                                {className: 'inputSMBShareLoginField theme-item-editable disabled'},
                                gettext('Login')
                            )
                        ],
                        click: function () {
                            keyboard.open({
                                title: gettext('ENTER LOGIN'),
                                value: smbAuthorizeModalList.loginAttempt ? $inputSMBShareLogin.innerText : ''
                            }, function ( event ) {
                                $inputSMBShareLogin.innerText = event.value || gettext('Login');
                                smbAuthorizeModalList.loginAttempt = !!event.value;
                            });
                        }
                    },
                    {
                        items: [
                            $inputSMBSharePassword = tag('div', {className: 'inputSMBSharePasswdField'}, gettext('Password')),
                            {
                                className: 'theme-item-editable disabled'
                            }
                        ],
                        click: function () {
                            keyboard.open({
                                title: gettext('ENTER PASSWORD'),
                                value: smbAuthorizeModalList.passwordAttempt ? $inputSMBSharePassword.innerText : '',
                                type: 'password'
                            }, function ( event ) {
                                event.value = event.value.trim();
                                smbAuthorizeModalList.passwordAttempt = !!event.value;

                                if ( event.value ) {
                                    $inputSMBSharePassword.password = event.value;
                                    $inputSMBSharePassword.innerText = event.value;
                                    $inputSMBSharePassword.classList.add('theme-text-password');
                                } else {
                                    $inputSMBSharePassword.classList.remove('theme-text-password');
                                    $inputSMBSharePassword.innerText = gettext('Password');
                                }
                            });
                        }
                    }
                ],
                events: {
                    overflow: function ( event ) {
                        if ( event.direction === keys.down || event.direction === keys.up ) {
                            this.blurItem(this.$focusItem);
                            buttonSmbShareAuthorize.focus();
                        }
                    }
                }
            }),
            buttonSmbShareAuthorize
        ]
    });

    modals.sort = new ModalMessage({
        title: gettext('sorting'),
        events: {
            show: function () {
                modals.sort.focus();
                app.runtime.isModalShown = true;
            }
        },
        children: [
            new RadioList({
                cycle: true,
                focusIndex: 0,
                size: 4,
                events: {
                    'click:item': function ( event ) {
                        var value = event.$item.value;

                        modals.sort.hide();

                        if ( value === 1 ) {
                            actualSorting = 'NAME';
                        } else if ( value === 2 ) {
                            actualSorting = 'DATE';
                        } else if ( value === 3 ) {
                            actualSorting = 'TYPE';
                        } else {
                            actualSorting = 'SIZE';
                        }

                        renderList(contentSort(actualSorting), listScroll, {focusIndex: 0});
                        menuSortingItem.innerText = event.$item.data.title;
                        panelSet.focus();
                        leftPanelMenu.focus();
                    }
                },
                data: [
                    {
                        state: true,
                        title: gettext('By name'),
                        value: 1
                    },
                    {
                        state: false,
                        title: gettext('By date'),
                        value: 2
                    },
                    {
                        state: false,
                        title: gettext('By type'),
                        value: 3
                    },
                    {
                        state: false,
                        title: gettext('By size'),
                        value: 4
                    }
                ]
            })
        ]
    });

    modals.filter = new ModalMessage({
        title: gettext('filtering'),
        events: {
            show: function () {
                modals.filter.focus();
                app.runtime.isModalShown = true;
                page.footer.hide();
            }
        },
        children: [
            filterMenuList = new CheckList({
                cycle: true,
                focusIndex: 0,
                data: filterItems,
                scroll: filterScroll
            })
        ]
    });

    modals.actions = new ModalMessage({
        title: gettext('actions'),
        events: {
            show: function () {
                app.runtime.isModalShown = true;
                modals.actions.focus();
            },
            hide: closeModalWindow,
            keydown: function ( event ) {
                if ( event.code === keys.ok ) {
                    this.hide();
                }
            }
        },
        children: [
            contextMenuList = new LayoutList({
                cycle: true,
                focusIndex: 0,
                data: []
            })
        ]
    });

    contextMenuList.render = function ( items ) {
        this.init({
            data: items,
            size: items.length,
            focusIndex: 0
        });
    };

    modalMessageActionsShow = modals.actions.show;

    modals.actions.show = function () {
        setTimeout(function () {
            modalMessageActionsShow.call(modals.actions);
            panelSet.blur();
        }, 40);
    };

    modals.createFolder = new ModalMessage({
        title: gettext('Create folder'),
        events: {
            show: function () {
                app.runtime.isModalShown = true;
                page.footer.hide();
            },
            hide: function () {
                createDirList.createAttempt = false;
                closeModalWindow();
            }
        },
        children: [
            createDirList = new LayoutList({
                className: 'padded',
                size: 1,
                focusIndex: 0,
                data: [
                    {
                        items: [
                            $inputFolderName = tag(
                                'div',
                                {className: 'inputFolderName theme-item-editable theme-text-disabled'},
                                gettext('New folder')
                            )
                        ],
                        click: function () {
                            keyboard.open({
                                title: gettext('ENTER FOLDER NAME'),
                                value: createDirList.createAttempt ? $inputFolderName.innerText : ''
                            }, function ( event ) {
                                $inputFolderName.innerText  = event.value || gettext('New folder');
                                createDirList.createAttempt = !!event.value;
                            });
                        }
                    }
                ],
                events: {
                    overflow: function ( event ) {
                        if ( event.direction === keys.down || event.direction === keys.up ) {
                            this.blurItem(this.$focusItem);
                            buttonCreate.focus();
                        }
                    }
                }
            }),
            buttonCreate
        ]
    });

    modals.renameShare = new ModalMessage({
        title: gettext('Rename'),
        events: {
            show: function () {
                app.runtime.isModalShown = true;
                page.footer.hide();
            },
            hide: function () {
                renameShareList.renameAttempt = false;
                closeModalWindow();
            }
        },
        children: [
            renameShareList = new LayoutList({
                className: 'padded',
                size: 1,
                focusIndex: 0,
                data: [
                    {
                        items: [
                            $inputShareName = tag(
                                'div',
                                {className: 'inputShareName theme-item-editable disabled'},
                                gettext('New name')
                            )
                        ],
                        click: function () {
                            keyboard.open({
                                title: gettext('ENTER FOLDER NAME'),
                                value: renameShareList.renameAttempt ? $inputShareName.innerText : ''
                            }, function ( event ) {
                                $inputShareName.innerText     = event.value || gettext('New name');
                                renameShareList.renameAttempt = !!event.value;
                            });
                        }
                    }
                ],
                events: {
                    overflow: function ( event ) {
                        if ( event.direction === keys.down || event.direction === keys.up) {
                            this.blurItem(this.$focusItem);
                            buttonRename.focus();
                        }
                    }
                }
            }),
            buttonRename
        ]
    });

    page.clock = new Flicker({
        parent: page,
        className: 'clock',
        interval: 1000,
        render: function ( $item ) {
            var time  = new Date(),
                hours = time.getHours(),
                mins  = time.getMinutes();

            $item.innerText = (hours > 9 ? hours : '0' + hours) + ':' + (mins > 9 ? mins : '0' + mins);
        }
    });

    page.clock.start();
    Object.keys(modals).forEach(modal => page.add(modals[modal]));

    page.add(
        panelSet = new PanelSet({
            panels: [
                new Panel({
                    size: 1,
                    title: [
                        {
                            value: gettext('menu'),
                            className: 'name'
                        }
                    ],
                    children: [
                        leftPanelMenu = new LayoutList({
                            cycle: true,
                            size: 5,
                            focusIndex: 0,
                            data: [
                                {
                                    items: [
                                        $inputSearchIcon = tag('div', {className: 'theme-icon theme-icon-search'}),
                                        $inputSearch = tag('div', {className: 'inputSearchField'}, gettext('Search'))
                                    ],
                                    click: hotKeyActions[actions.search]
                                },
                                {
                                    items: [
                                        {
                                            className: 'theme-icon theme-icon-sort-az'
                                        },
                                        {
                                            value: gettext('By name'),
                                            className: 'theme-item-more'
                                        }
                                    ],
                                    click: function () {
                                        // do nothing if there are no items for searching
                                        if ( !breadcrumbs.config.type || (breadcrumbs.config.type === mediaTypes.network.id && breadcrumbs.head.type < mediaTypes.smbShare) ) {
                                            return;
                                        }

                                        panelSet.blur();
                                        modals.sort.show();
                                        modals.sort.focus();
                                    }
                                },
                                {
                                    items: [
                                        {
                                            className: 'theme-icon theme-icon-filter'
                                        },
                                        {
                                            value: gettext('All'),
                                            className: 'theme-item-more'
                                        }
                                    ],
                                    click: function () {
                                        var availableTypes, currentTypes;

                                        if (
                                            !breadcrumbs.config.type
                                            || breadcrumbs.config.stageType === mediaTypes.upnpServer
                                            || breadcrumbs.config.stageType === mediaTypes.upnpHost
                                        ) {
                                            return;
                                        }

                                        groupFilesByType(listFile.map(file => file.value.item));

                                        // show only available types in filter menu
                                        availableTypes = Object.keys(filesByType);

                                        currentTypes = filterItems.filter(function ( item ) {
                                            return availableTypes.indexOf(String(item.value)) !== -1;
                                        });

                                        if ( listFolder.length ) {
                                            currentTypes.unshift(filterItems[0]);
                                        }

                                        // block filters invocation in empty folders
                                        if ( !currentTypes.length ) {
                                            return;
                                        }

                                        filterMenuList.init({
                                            data:       currentTypes,
                                            size:       currentTypes.length < 6 ? currentTypes.length : 5,
                                            scroll:     currentTypes.length < 6 ? null : filterScroll,
                                            focusIndex: 0
                                        });
                                        panelSet.blur();
                                        modals.filter.show();
                                        modals.filter.focus();
                                    }
                                },
                                {
                                    items: [
                                        {
                                            className: 'theme-icon theme-icon-network'
                                        },
                                        {
                                            value: gettext('Mount share'),
                                            className: 'theme-item-more'
                                        }
                                    ],
                                    click: function () {
                                        app.route(app.pages.connect);
                                    }
                                },
                                {
                                    items: [
                                        {
                                            className: 'theme-icon theme-icon-exit'
                                        },
                                        {
                                            value: gettext('Exit')
                                        }
                                    ],
                                    click: function () {
                                        appExit.goExit(panelSet);
                                    }
                                }
                            ]
                        })
                    ],
                    events: {
                        focus: function ( event ) {
                            Panel.prototype.defaultEvents.focus.call(this, event);
                            initFooter([
                                [
                                    keys.menu, function () {
                                        contextMenuList.render([contextMenuItems.resetFilters]);
                                        modals.actions.show();
                                        page.footer.hide();
                                    }
                                ],
                                [[keys.f1, gettext('Reset filters'), hotKeyActions[actions.resetFilters]]]
                            ]).show();
                        }
                    }
                }),
                mainPanel = new Panel({
                    size: 1,
                    title: [
                        {
                            value: gettext('files'),
                            className: 'name'
                        },
                        tag('div', {className: 'amountContainer'}, headerAmount = tag('div', {className: 'amount'}, 0))
                    ],
                    main: true,
                    children: !page.loaded && [
                        mainPanelList = new LayoutList({
                            cycle:      true,
                            focusIndex: 0,
                            size:       defaultListSize,
                            data:       renderFilesListInitial(),
                            scroll:     listScroll,
                            noData:     ''
                        })
                    ]
                }),
                rightPanel = new Panel({
                    size: 1,
                    title: [
                        {
                            value: gettext('details'),
                            className: 'name'
                        }
                    ],
                    children: []
                })
            ]
        })
    );

    diagram.init(rightPanel, [mainPanelList.$body.children[0], mainPanel.$node, mainPanel.$node]);
    renderDetailsList('0000000', [null, null, null, null, null, null, null]);
    rightPanel.add(page.textArea, rightInfoPanelScroll);
    menuSortingItem = leftPanelMenu.$body.children[1].children[0].children[1];
    menuFilteringItem = leftPanelMenu.$body.children[2].children[0].children[1];
    mainPanel.$body.appendChild(listScroll.$node);
    modals.filter.$body.appendChild(filterScroll.$node);

    if ( renderFilesListInitial.itemsLength <= defaultListSize ) {
        listScroll.$node.style.display = 'none';
    }

    headerAmount.innerHTML = breadcrumbs.config.type ? data.length - 1 : renderFilesListInitial.itemsLength;
    mainPanelTitle = mainPanel.title.$body.children[0];
    filterMenuList.title = filterMenuList.title || [];
    filterMenuList.types = filterMenuList.types || [];
    mainPanel.focus();
    constructFavoritesInfo();

    rightPanel.addListener('focus', function () {
        page.footer.hide();
    });

    mainPanel.addListener('focus', function () {
        var target = mainPanelList.$focusItem;

        if ( breadcrumbs.config.type || (!breadcrumbs.config.type && target && target.data && target.data.value && (target.data.value.deviceType === 5 || target.data.value.type === 1)) ) {
            mainPanelList.emit('focus:item');
        } else {
            page.footer.hide();
        }
    });

    filterMenuList.addListener('keydown', function ( event ) {
        var titleLength;

        if ( event.code === keys.back ) {
            Array.prototype.forEach.call(filterMenuList.$body.children, function ( item ) {
                if ( item.state ) {
                    if ( filterMenuList.types.indexOf(item.data.value) === -1 ) {
                        filterMenuList.types.push(item.data.value);
                    }

                    if ( filterMenuList.title.indexOf(item.data.title) === -1 ) {
                        filterMenuList.title.push(item.data.title);
                    }
                } else if ( item.data ) {
                    if ( filterMenuList.types.indexOf(item.data.value) !== -1 ) {
                        filterMenuList.types.splice(filterMenuList.types.indexOf(item.data.value), 1);
                    }

                    if ( filterMenuList.title.indexOf(item.data.title) !== -1 ) {
                        filterMenuList.title.splice(filterMenuList.title.indexOf(item.data.title), 1);
                    }
                }
            });

            // update filtering items to current state
            filterItems = filterItems.map(function ( item ) {
                item.state = filterMenuList.types.indexOf(item.value) !== -1;

                return item;
            });

            filterAtCurrentOutput(filterMenuList.types);
            titleLength = filterMenuList.title.length;

            if ( titleLength > 2 ) {
                menuFilteringItem.innerText = filterMenuList.title.slice(0, 2).join(', ') + ', ...';
            } else if ( titleLength && titleLength < 3 ) {
                menuFilteringItem.innerText = filterMenuList.title.slice(0, 2).join(', ');
            } else {
                menuFilteringItem.innerText = resetFilter();
            }
        }
    });

    mainPanelList.addListener('keydown', function ( event ) {
        var targetNode = mainPanelList.$focusItem;

        if ( breadcrumbs.config.type ) {
            if ( breadcrumbs.config.type === 1 ) {
                if ( breadcrumbs.config.currentDeviceType !== 5 ) {
                    if ( event.code === keys.del ) {
                        if (
                            breadcrumbs.config.isDisplayFavorites ||
                            !targetNode.data.value ||
                            breadcrumbs.config.isDisplaySmbShares ||
                            breadcrumbs.config.isDeviceReadOnly
                        ) {
                            return;
                        }

                        echo({
                            title: gettext('Are you sure you want to delete this item?'),
                            icon: 'info',
                            type: '',
                            buttons: [
                                {
                                    value: gettext('Cancel')
                                },
                                {
                                    value: gettext('Ok'),
                                    click: removeFileSystemObject
                                }
                            ]

                        });
                    }
                }
            }
        } else if ( event.code === keys.del ) {
            echo({
                title: gettext('Are you sure you want to delete this item?'),
                icon: 'info',
                type: '',
                buttons: [
                    {
                        value: gettext('Cancel')
                    },
                    {
                        value: gettext('Ok'),
                        click: removePermanentShare
                    }
                ]
            });
        }
    });

    (function () {
        var delay = core.environment.onFocusDebounceTimeout || 400,
            footerButtons = [],
            timerId;

        mainPanelList.addListener('focus:item', function () { // eslint-disable-line
            var target = mainPanelList.$focusItem,
                fileSystemObject;

            if ( folderListView ) {
                clearTimeout(timerId);
                fileSystemObject = folderListView[target.index];
                if ( fileSystemObject && fileSystemObject.value ) {
                    timerId = setTimeout(function () {
                        if ( fileSystemObject.value.type === 9 || fileSystemObject.value.type === 10 ) {
                            switch ( fileSystemObject.value.item.subtype ) {
                                case FILE_SUBTYPE.playlistFile:
                                    renderDetailsList(
                                        '01000001',
                                        [null, fileSystemObject.value.name, null, null, null, null, null, fileSystemObject.value.item.uri]
                                    );
                                    footerButtons = [];

                                    if ( !breadcrumbs.config.isDisplaySmbShares ) {
                                        footerButtons = [[],  [[keys.f3, gettext('Favorites'), hotKeyActions[actions.setFavoritesState]]]];
                                    }
                                    break;
                                case FILE_SUBTYPE.playlistStream:
                                    renderDetailsList(
                                        '01000001',
                                        [null, fileSystemObject.value.name, null, null, null, null, null, fileSystemObject.value.item.path],
                                        fileSystemObject.value.item.additionalData ? {nodes: fileSystemObject.value.item.additionalData} : null
                                    );

                                    footerButtons = [
                                        [
                                            keys.menu, function () {
                                                contextMenuList.render([contextMenuItems.setFavoritesState]);
                                                modals.actions.show();
                                                page.footer.hide();
                                            }
                                        ], [[keys.f3, gettext('Favorites'), hotKeyActions[actions.setFavoritesState]]]
                                    ];

                                    break;
                                default:
                                    if ( fileSystemObject.value.item.type === mediaTypes.fileCUE.id ) {
                                        constructCueInfo(fileSystemObject.value.item);
                                    } else if ( fileSystemObject.value.item.type === mediaTypes.fileImage.id ) {
                                        previewImage(
                                            page.textArea,
                                            'file://' + breadcrumbs.path + fileSystemObject.value.name,
                                            fileSystemObject.value
                                        );
                                    } else {
                                        renderDetailsList(
                                            '0111000',
                                            [
                                                null,
                                                fileSystemObject.value.name,
                                                new Date(fileSystemObject.value.item.lastModified).toLocaleDateString(),
                                                evalSpace(fileSystemObject.value.item.size),
                                                null,
                                                null,
                                                null
                                            ]
                                        );
                                    }

                                    footerButtons = [[], [[keys.f3, gettext('Favorites'), hotKeyActions[actions.setFavoritesState]]]];

                                    if ( breadcrumbs.config.isDisplayFavorites || breadcrumbs.config.isDeviceReadOnly ) {
                                        footerButtons[0] = [
                                            keys.menu, function () {
                                                contextMenuList.render([contextMenuItems.setFavoritesState]);
                                                modals.actions.show();
                                                page.footer.hide();
                                            }
                                        ];
                                    } else {
                                        footerButtons[0] = [
                                            keys.menu, function () {
                                                contextMenuList.render([
                                                    contextMenuItems.deleteFile,
                                                    contextMenuItems.createFolder,
                                                    contextMenuItems.setFavoritesState
                                                ]);
                                                modals.actions.show();
                                                page.footer.hide();
                                            }
                                        ];
                                        footerButtons[1].unshift(
                                            [keys.f1, gettext('Delete'), hotKeyActions[actions.deleteFile]],
                                            [keys.f2, gettext('Create folder'), hotKeyActions[actions.createFolder]]
                                        );
                                    }
                            }

                            if ( breadcrumbs.config.type !== 1 && (fileSystemObject.value.item.type === '14' || breadcrumbs.config.isDisplayPlaylist) ) {
                                if ( MODE === 'portal' && (fileSystemObject.value.item.type === '14' || breadcrumbs.config.isDisplayPlaylist ) ) { // eslint-disable-line
                                    footerButtons = [[keys.menu], [[keys.f4, gettext('Search'), hotKeyActions[actions.search]]]];
                                    initFooter(footerButtons);
                                } else {
                                    footerButtons = [[], [[keys.f4, gettext('Search'), hotKeyActions[actions.search]]]];
                                    initFooter(footerButtons);
                                }
                            }

                            breadcrumbs.config.type === 1 && breadcrumbs.config.currentDeviceType !== 5 && initFooter(footerButtons);
                        } else {
                            renderDetailsList('0100000', [null, fileSystemObject.value.name, null, null, null, null, null]);

                            if ( breadcrumbs.config.type === 1 && breadcrumbs.config.currentDeviceType !== 5 ) {
                                if ( breadcrumbs.config.isDeviceReadOnly ) {
                                    footerButtons = [
                                        [
                                            keys.menu, function () {
                                                contextMenuList.render([contextMenuItems.setFavoritesState]);
                                                modals.actions.show();
                                                page.footer.hide();
                                            }
                                        ], [[keys.f3, gettext('Favorites'), hotKeyActions[actions.setFavoritesState]]]
                                    ];

                                    initFooter(footerButtons).show();
                                } else {
                                    initFooter([
                                        [
                                            keys.menu, function () {
                                                contextMenuList.render([
                                                    contextMenuItems.deleteFile,
                                                    contextMenuItems.createFolder,
                                                    contextMenuItems.setFavoritesState
                                                ]);
                                                modals.actions.show();
                                                page.footer.hide();
                                            }
                                        ], [
                                            [keys.f1, gettext('Delete'), hotKeyActions[actions.deleteFile]],
                                            [keys.f2, gettext('Create folder'), hotKeyActions[actions.createFolder]],
                                            [keys.f3, gettext('Favorites'), hotKeyActions[actions.setFavoritesState]]
                                        ]
                                    ]).show();
                                }
                            }

                            if ( breadcrumbs.config.currentDeviceType === 5 ) {
                                footerButtons = [[], [[keys.f4, gettext('Search'), hotKeyActions[actions.search]]]];
                                initFooter(footerButtons);
                            }
                        }
                    }, delay);
                } else {
                    if ( breadcrumbs.config.currentDeviceType === 5 ) {
                        footerButtons = [[], [[keys.f4, gettext('Search'), hotKeyActions[actions.search]]]];
                        initFooter(footerButtons);
                    }

                    renderDetailsList('1000000', [breadcrumbs.config.currentDirFilesCount + '', null, null, null, null, null, null]);

                    if ( breadcrumbs.config.currentDeviceType !== 5 && !breadcrumbs.config.isDisplayFavorites && !breadcrumbs.head.isDisplayPlaylist && !breadcrumbs.config.isDeviceReadOnly ) {
                        initFooter([
                            [
                                keys.menu, function () {
                                    contextMenuList.render([contextMenuItems.createFolder]);
                                    modals.actions.show();
                                    page.footer.hide();
                                }
                            ], [[keys.f2, gettext('Create folder'), hotKeyActions[actions.createFolder]]]
                        ]).show();
                    }

                    if ( breadcrumbs.config.isDisplayFavorites ) {
                        initFooter([
                            [
                                keys.menu, function () {
                                    contextMenuList.render([contextMenuItems.setFavoritesState]);
                                    modals.actions.show();
                                    page.footer.hide();
                                }
                            ],
                            [[keys.f3, gettext('Favorites'), hotKeyActions[actions.setFavoritesState]]]
                        ]).show();
                    }

                    if ( breadcrumbs.config.type === 1 && breadcrumbs.config.isDeviceReadOnly ) {
                        page.footer.hide();
                    }
                }
            }

            if ( breadcrumbs.config.type === mediaTypes.network.id ) {
                initFooter([
                    [
                        keys.menu, function () {
                            contextMenuList.render([
                                contextMenuItems.clearSmbCache,
                                contextMenuItems.search
                            ]);
                            modals.actions.show();
                            page.footer.hide();
                        }
                    ],
                    [
                        [keys.f1, gettext('Clear cache'), hotKeyActions[actions.clearSmbCache]],
                        [keys.f4, gettext('Search'), hotKeyActions[actions.search]]
                    ]
                ]).show();

                if ( breadcrumbs.config.type === mediaTypes.nfsServer || breadcrumbs.config.type === mediaTypes.nfsShare ) {
                    initFooter([
                        [
                            keys.menu, function () {
                                contextMenuList.render([
                                    contextMenuItems.clearNfsCache,
                                    contextMenuItems.search
                                ]);
                                modals.actions.show();
                                page.footer.hide();
                            }
                        ],
                        [
                            [keys.f1, gettext('Clear cache'), hotKeyActions[actions.clearNfsCache]],
                            [keys.f4, gettext('Search'), hotKeyActions[actions.search]]
                        ]
                    ]).show();
                }

                if (
                    (breadcrumbs.head && breadcrumbs.head.type === mediaTypes.smbServer) && target.index
                    || (breadcrumbs.length === 5 && !target.index)
                    || (MODE === 'portal' && breadcrumbs.config.isDisplayPlaylist)
                ) {
                    initFooter([
                        [
                            keys.menu, function () {
                                contextMenuList.render([contextMenuItems.pinShare]);
                                modals.actions.show();
                                page.footer.hide();
                            }
                        ]
                    ]).show();
                }
            }

            if ( breadcrumbs.config.type === mediaTypes.upnp.id ) {
                initFooter([
                    [
                        keys.menu, function () {
                            contextMenuList.render([contextMenuItems.search]);
                            modals.actions.show();
                            page.footer.hide();
                        }
                    ],
                    [[keys.f4, gettext('Search'), hotKeyActions[actions.search]]]
                ]).show();

                if ( breadcrumbs.config.stageType === mediaTypes.upnpHost || breadcrumbs.config.stageType === mediaTypes.upnpDir ) {
                    clearTimeout(timerId);
                    timerId = setTimeout(function () {
                        if ( target.index ) {
                            if ( breadcrumbs.config.stageType === mediaTypes.upnpDir ) {
                                // files
                                if ( target.value.type === 10 ) {
                                    // images
                                    if ( target.value.item.type === mediaTypes.fileImage.id ) {
                                        previewImage(page.textArea, target.value.item.path, {name: target.value.item.name, item: target.value.item});
                                    }
                                }
                            }

                            renderDetailsList(
                                '010' + +(target.value.type === 10) + '000' + +(target.value.type === 10),
                                [
                                    null,
                                    target.value.name,
                                    null,
                                    target.value.type === 10 ? evalSpace(target.value.item.size) : null,
                                    null,
                                    null,
                                    null,
                                    target.value.type === 10 ? target.value.item.path : null
                                ]
                            );
                        } else {
                            renderDetailsList('0000000', [null, null, null, null, null, null, null]);
                        }
                    }, delay);
                }
            }

            if ( !breadcrumbs.config.type ) {
                if ( target.data && target.data.value && target.data.value.deviceType === 8 ) {
                    page.footer.hide();

                    renderDetailsList(
                        '0000110',
                        [
                            null,
                            null,
                            null,
                            null,
                            target.data.value.sizeOverview,
                            target.data.value.fsType + (target.data.value.isReadOnly ? ' (' + gettext('read-only') + ')' : ''),
                            null
                        ]
                    );

                    diagram.draw({size: target.data.value.fullSize, free: target.data.value.freeSize});
                } else if ( target.data && target.data.value && (target.data.value.deviceType === 5 || target.data.value.deviceType === mediaTypes.nfsPermanentShare) ) {
                    constructShareInfo(target.data.value);

                    initFooter([
                        [
                            keys.menu, function () {
                                contextMenuList.render([
                                    contextMenuItems.unpinShare,
                                    contextMenuItems.renamePinnedShare
                                ]);
                                modals.actions.show();
                                page.footer.hide();
                            }
                        ], [
                            [
                                keys.f1, gettext('Delete'), function () {
                                    echo({
                                        title: gettext('Are you sure you want to delete this shared folder?'),
                                        icon: 'info',
                                        type: '',
                                        buttons: [
                                            {
                                                value: gettext('Cancel')
                                            },
                                            {
                                                value: gettext('Ok'),
                                                click: removePermanentShare
                                            }
                                        ]
                                    });
                                }
                            ], [keys.f4, gettext('Rename'), hotKeyActions[actions.renamePinnedShare]]
                        ]
                    ]).show();
                } else if ( target.data && target.data.value && target.data.value.type === 1 ) {
                    if ( app.storage.favoritesStorage.length ) {
                        initFooter([
                            [
                                keys.menu, function () {
                                    contextMenuList.render([contextMenuItems.clearFavorites]);
                                    modals.actions.show();
                                    page.footer.hide();
                                }
                            ],
                            [[keys.f1, gettext('Clear'), hotKeyActions[actions.clearFavorites]]]
                        ]).show();
                    } else {
                        page.footer.hide();
                    }

                    constructFavoritesInfo();
                } else {
                    page.footer.hide();
                    renderDetailsList('0000000', [null, null, null, null, null, null, null]);
                }
            }

            /*if ( MODE === 'portal' && breadcrumbs.config.isDisplayPlaylist ) {
                initFooter([[keys.menu], [[keys.f4, gettext('Search'), hotKeyActions[actions.search]]]]);
            }*/
        });
    })();

    mainPanelList.addListener('move:view', function () {
        mainPanelList && mainPanelList.$focusItem && mainPanelList.emit('focus:item');
    });

    buttonCreate.addListener('click', function () {
        var nameToSet = $inputFolderName.innerText.slice(0, 255),
            path;

        fs.isFolderExist(
            path = breadcrumbs.path + nameToSet,
            function ( error, isExist ) {
                if ( isExist ) {
                    echo({
                        title: gettext('Folder with this name already exists'),
                        icon: 'info'
                    });
                } else {
                    console.log(error);
                    fs.createDir(path, function ( error, dirCreated ) {
                        if ( !error && dirCreated ) {
                            renderList(
                                (folderListView.splice(
                                    mainPanelList.$focusItem.index + 1,
                                    0,
                                    {
                                        items: [
                                            {
                                                className: 'theme-icon theme-icon-folder'
                                            },
                                            {
                                                value: nameToSet,
                                                className: 'listDirNameField'
                                            },
                                            {
                                                className: 'theme-icon'
                                            }
                                        ],
                                        value: {
                                            name: nameToSet,
                                            type: 9,
                                            item: {
                                                name: nameToSet,
                                                type: 9
                                            }
                                        },
                                        click: function () {
                                            breadcrumbs.push({
                                                index: mainPanelList.$focusItem.index,
                                                path: nameToSet
                                            });
                                            fs.readDir(breadcrumbs.path, function ( error, result ) {
                                                if ( !error ) {
                                                    breadcrumbs.config.currentDirFilesCount = result.dirs.length + result.files.length;
                                                    renderList(constructDataOut(result, 1), null, {focusIndex: 0});
                                                    renderDetailsList('1000000', [breadcrumbs.config.currentDirFilesCount + '', null, null, null, null, null, null]);
                                                }
                                            });
                                        }
                                    }
                                ), folderListView),
                                listScroll,
                                {focusIndex: mainPanelList.$focusItem.index + 1}
                            );

                            closeModalWindow();
                            $inputFolderName.innerText = gettext('New folder');
                        } else {
                            echo({
                                title: gettext('Can not set folder name to') + ' "' + nameToSet + '". ' + gettext('Unsupported symbols'),
                                icon: 'info'
                            });
                        }
                    });
                }
            }
        );
    });

    buttonCreate.addListener('keydown', function ( event ) {
        if ( event.code === keys.up || event.code === keys.down ) {
            createDirList.focus();
            createDirList.focusIndex(0);
        }
    });

    buttonRename.addListeners({
        click: function () {
            renamePinnedShare($inputShareName.innerText);
            closeModalWindow();
        },
        keydown: function ( event ) {
            if ( event.code === keys.up || event.code === keys.down ) {
                renameShareList.focus();
                renameShareList.focusIndex(0);
            }
        }
    });

    buttonSmbShareAuthorize.addListeners({
        click: function () {
            var login      = $inputSMBShareLogin.innerText,
                password   = $inputSMBSharePassword.password,
                targetItem = mainPanelList.$focusItem.data,
                itemData   = targetItem.value.details || targetItem.value.item,
                path       = {
                    addresses: itemData.addresses,
                    folder:    itemData.name,
                    login:     login,
                    password:  password,
                    mountPath: app.config.mountPathSMB
                };

            itemData.login    = login;
            itemData.password = password;

            if ( app.runtime.stillWaitNetworkResponse ) {
                return;
            }

            app.runtime.stillWaitNetworkResponse = true;
            closeModalWindow();
            smbTraverse('openShare', path, {});
        },
        keydown: function ( event ) {
            if ( event.code === keys.up ) {
                smbAuthorizeModalList.focus();
                smbAuthorizeModalList.focusIndex(1);
            } else if ( event.code === keys.down ) {
                smbAuthorizeModalList.focus();
                smbAuthorizeModalList.focusIndex(0);
            }
        }
    });

    buttonSmbServerAuthorize.addListeners({
        click: function () {
            var login      = $inputSMBServerLogin.innerText,
                password   = $inputSMBServerPassword.password,
                targetItem = mainPanelList.$focusItem.data,
                itemData   = targetItem.value.item,
                path       = {server: itemData.name, login: login || '', password: password || ''};

            itemData.login    = login;
            itemData.password = password;

            if ( app.runtime.stillWaitNetworkResponse ) {
                return;
            }

            app.runtime.stillWaitNetworkResponse = true;
            closeModalWindow();
            smbTraverse('getShares', path, smbTraverse.cache.getShares.config, smbTraverse.cache.getShares.callback);
        },
        keydown: function ( event ) {
            if ( event.code === keys.up ) {
                authorizeSmbServerList.focus();
                authorizeSmbServerList.focusIndex(1);
            } else if ( event.code === keys.down ) {
                authorizeSmbServerList.focus();
                authorizeSmbServerList.focusIndex(0);
            }
        }
    });

    fs.onMount = function ( state ) {
        var deviceViewIndex;

        if ( state ) {
            if ( !breadcrumbs.config.type ) {
                renderList(renderFilesListInitial(), listScroll, mainPanelList.$focusItem ? {focusIndex: mainPanelList.$focusItem.index} : null);
            }

        } else if ( !breadcrumbs.config.type ) {
            deviceViewIndex = mainPanelList.$focusItem.index;
            renderList(renderFilesListInitial(), listScroll, {focusIndex: deviceViewIndex - (renderFilesListInitial.itemsLength === deviceViewIndex)});
        } else if ( breadcrumbs.config.stageType === 8 ) {
            // eslint-disable-next-line
            fs.isFolderExist(breadcrumbs.config.currentDevice.mountPath, function ( error, result ) {
                var index, items;

                if ( !result ) {
                    items = renderFilesListInitial();
                    index = breadcrumbs.config.entryPointIndex;
                    breadcrumbs.emit('reset');
                    page.footer.hide();
                    renderList(items, listScroll, {focusIndex: renderFilesListInitial.itemsLength === index ? index - 1 : index});
                }
            });
        }
    };
}


/** Handler for "Back" button. */
// eslint-disable-next-line complexity, max-statements
function goBack () {
    var renderRoot = function () {
            mainPanel.$node.classList.remove('networkView');
            breadcrumbs.config.type = 0;
            folderListView = null;
            breadcrumbs.config.currentDeviceType = null;
            breadcrumbs.config.isDisplayNfsShare = null;
            renderList(renderFilesListInitial(), null, {focusIndex: breadcrumbs.config.entryPointIndex});
            page.footer.hide();
            mainPanelTitle.innerText = gettext('files');
            app.runtime.stillWaitNetworkResponse = false;
        },
        breadcrumbsLength, focusIndex, favorites;

    if ( !breadcrumbs.length && breadcrumbs.config.isDisplayFavorites ) {
        renderList(renderFilesListInitial.currentStdout, listScroll, {focusIndex: breadcrumbs.config.entryPointIndex});
        breadcrumbs.emit('reset');
        renderDetailsList('0000000', [null, null, null, null, null, null, null]);
        mainPanelList.emit('focus:item');
        mainPanelTitle.innerText = gettext('files');
        constructFavoritesInfo();

        return;
    }

    if ( breadcrumbs.config.type !== mediaTypes.upnp.id ) {
        searchAtCurrentOutput.focusToIndex = focusIndex = breadcrumbs.head ? breadcrumbs.head.index : 0;
        breadcrumbs.pop();
        breadcrumbsLength = breadcrumbs.length;
    }

    if ( breadcrumbs.config.isDisplayPlaylist ) {
        breadcrumbs.config.isDisplayPlaylist = false;
    }

    if ( breadcrumbs.config.isDisplayFavorites && !breadcrumbs.length ) {
        favorites = app.storage.favoritesStorage;
        breadcrumbs.config.currentDirFilesCount = favorites.length;
        renderList(
            constructDataOut({
                dirs: favorites.filter(function ( item ) { return item.type === 9; }),
                files: favorites.filter(function ( item ) { return item.type > 9; })
            }, 1),
            listScroll,
            {focusIndex: focusIndex}
        );
        mainPanelTitle.innerText = gettext('Favorites');
    } else if ( breadcrumbs.config.currentDeviceType === mediaTypes.nfsPermanentShare ) {
        if ( breadcrumbs.length ) {
            mainPanelTitle.innerText = breadcrumbs.head.folder || breadcrumbs.head.path;

            fs.readDir(breadcrumbs.path, function ( error, result ) {
                if ( !error ) {
                    breadcrumbs.config.currentDirFilesCount = result.dirs.length + result.files.length;
                    renderList(constructDataOut(result, 1), listScroll, {focusIndex: focusIndex});
                    renderDetailsList('1000000', [breadcrumbs.config.currentDirFilesCount + '', null, null, null, null, null, null]);
                }
            });

            // display information about actual filters
            menuFilteringItem.innerText = filterMenuList.title.length ? filterMenuList.title.join(', ') : resetFilter();
            filterAtCurrentOutput(filterMenuList.types, 'back');
        } else {
            renderRoot();
        }
    } else if ( breadcrumbs.config.isDisplayNfsShare ) {
        if ( breadcrumbs.length === 3 ) {
            if ( app.runtime.stillWaitNetworkResponse ) {
                return;
            }

            app.runtime.stillWaitNetworkResponse = true;
            nfsTraverse('getShares', {server: app.runtime.currentServer.path}, {icon: 'theme-icon-shared-folder', index: focusIndex}, function () {
                breadcrumbs.config.isDisplayNfsShare = false;
                breadcrumbs.pop();
                mainPanelTitle.innerText = 'NFS';
                app.runtime.stillWaitNetworkResponse = false;
            });
        } else {
            mainPanelTitle.innerText = breadcrumbs.head.folder || breadcrumbs.head.path;
            fs.readDir(breadcrumbs.path.split('/').slice(3).join('/'), function ( error, result ) {
                if ( !error ) {
                    breadcrumbs.config.currentDirFilesCount = result.dirs.length + result.files.length;
                    renderList(constructDataOut(result, 1), listScroll, {focusIndex: focusIndex});
                    renderDetailsList('1000000', [breadcrumbs.config.currentDirFilesCount + '', null, null, null, null, null, null]);
                }
            });
            // display information about actual filters
            menuFilteringItem.innerText = filterMenuList.title.length ? filterMenuList.title.join(', ') : resetFilter();
            filterAtCurrentOutput(filterMenuList.types, 'back');
        }
    } else if ( breadcrumbs.config.type === mediaTypes.network.id && breadcrumbsLength === 4 ) {
        if ( app.runtime.stillWaitNetworkResponse ) {
            return;
        }

        app.runtime.stillWaitNetworkResponse = true;
        folderListView = null;
        smbTraverse('getShares', {server: app.runtime.currentServer.path}, {icon: 'theme-icon-shared-folder', index: focusIndex}, function () {
            renderDetailsList('0000000', [null, null, null, null, null, null, null]);
            breadcrumbs.pop();
            mainPanelList.emit('focus:item');
            mainPanelTitle.innerText = 'SAMBA';
            app.runtime.stillWaitNetworkResponse = false;
        });
    } else if ( breadcrumbs.config.type === mediaTypes.network.id && breadcrumbsLength > 4 ) {
        if ( breadcrumbs.length === 5 ) {
            mainPanelTitle.innerText = breadcrumbs.head.path.folder;
        }

        mainPanelTitle.innerText = breadcrumbs.head.folder || breadcrumbs.head.path;
        fs.readDir(breadcrumbs.path, function ( error, result ) {
            if ( !error ) {
                breadcrumbs.config.currentDirFilesCount = result.dirs.length + result.files.length;
                renderList(constructDataOut(result, 1), listScroll, {focusIndex: focusIndex});
                renderDetailsList('1000000', [breadcrumbs.config.currentDirFilesCount + '', null, null, null, null, null, null]);
            }
        });

        // display information about actual filters
        menuFilteringItem.innerText = filterMenuList.title.length ? filterMenuList.title.join(', ') : resetFilter();
        filterAtCurrentOutput(filterMenuList.types, 'back');
    } else if ( breadcrumbs.config.type === 1 || breadcrumbs.config.type === mediaTypes.folder.id ) {
        if ( breadcrumbs.config.isDisplayFavorites && breadcrumbs.length === 1 ) {
            fs.readDir(breadcrumbs.path, function ( error, result ) {
                if ( !error ) {
                    breadcrumbs.config.currentDirFilesCount = result.dirs.length + result.files.length;
                    renderList(constructDataOut(result, 1), listScroll, {focusIndex: focusIndex});
                    renderDetailsList('1000000', [breadcrumbs.config.currentDirFilesCount + '', null, null, null, null, null, null]);
                    mainPanelTitle.innerText = breadcrumbs.head.path.replace(/^.*\//, '');
                }
            });
        } else if ( breadcrumbsLength ) {
            fs.readDir(breadcrumbs.path, function ( error, result ) {
                var currentDevice = breadcrumbs.config.currentDevice;

                if ( !error ) {
                    breadcrumbs.config.currentDirFilesCount = result.dirs.length + result.files.length;

                    if ( breadcrumbs.length === 1 ) {
                        if ( currentDevice ) {
                            mainPanelTitle.innerText = breadcrumbs.config.isDisplaySmbShares ? currentDevice.name : currentDevice.label || currentDevice.vendor || currentDevice.model;
                        }
                    } else {
                        mainPanelTitle.innerText = breadcrumbs.head.path;
                    }

                    // display information about actual filters
                    menuFilteringItem.innerText = filterMenuList.title.length ? filterMenuList.title.join(', ') : resetFilter();
                    renderList(constructDataOut(result, 1), listScroll, {focusIndex: focusIndex});
                    filterAtCurrentOutput(filterMenuList.types, 'back');
                }
            });
        } else {
            focusIndex = breadcrumbs.config.entryPointIndex;
            breadcrumbs.emit('reset');
            mainPanelTitle.innerText = gettext('files');
            page.footer.hide();
            renderList(renderFilesListInitial(), listScroll, {focusIndex: focusIndex});
        }
    } else if ( breadcrumbs.config.type === mediaTypes.network.id && breadcrumbsLength < 4 ) {
        page.footer.hide();

        if ( app.runtime.stillWaitNetworkResponse ) {
            return;
        }

        app.runtime.stillWaitNetworkResponse = true;

        if ( breadcrumbs.length === 3 ) {
            smbTraverse('getShares', {server: breadcrumbs.head.path}, {icon: 'theme-icon-shared-folder', index: focusIndex}, function () {
                breadcrumbs.config.isDisplaySmbShares = false;
                mainPanelTitle.innerText = 'SAMBA';
                app.runtime.stillWaitNetworkResponse = false;
            });
        } else if ( breadcrumbs.length === 2 ) {
            folderListView = null;

            smbTraverse('getServers', breadcrumbs.head.path, {icon: 'theme-icon-server', index: focusIndex}, function () {
                mainPanelTitle.innerText = gettext('servers');
                app.runtime.stillWaitNetworkResponse = false;
            });
        } else if ( breadcrumbs.length === 1 ) {
            smbTraverse('getGroups', null, {icon: 'theme-icon-workgroup', index: focusIndex}, function () {
                mainPanelTitle.innerText = gettext('work groups');
                app.runtime.stillWaitNetworkResponse = false;
            });
        } else {
            renderRoot();
        }
    } else if ( breadcrumbs.config.type === mediaTypes.upnp.id ) {
        if ( breadcrumbs.config.stageType === mediaTypes.upnpServer ) {
            renderList(renderFilesListInitial(), listScroll, {focusIndex: breadcrumbs.config.entryPointIndex});
            breadcrumbs.emit('reset');
            mainPanelTitle.innerText = gettext('files');
        } else if ( breadcrumbs.config.stageType === mediaTypes.upnpHost ) {
            focusIndex = breadcrumbs.head.index;

            upnp.openRoot( null, null, function ( error, result ) {
                if ( error ) {
                    echo({
                        title: gettext(error.message),
                        icon: 'alert',
                        type: 'warning'
                    });
                } else {
                    breadcrumbs.config.stageType = mediaTypes.upnpServer;

                    if ( result.length < focusIndex ) {
                        focusIndex = 0;
                    }

                    renderList(constructDataOut(result, mediaTypes.upnp.id), listScroll, {focusIndex: focusIndex});
                    breadcrumbs.pop();
                }
            });
        } else if ( breadcrumbs.config.stageType === mediaTypes.upnpDir ) {
            focusIndex = breadcrumbs.head.index;

            if ( breadcrumbs.length === 2 ) {
                upnp.openServer(breadcrumbs.tail.url, function ( error, result ) {
                    if ( !error ) {
                        breadcrumbs.config.stageType = mediaTypes.upnpHost;

                        if ( result.length < focusIndex ) {
                            focusIndex = 0;
                        }

                        renderList(constructDataOut(result, mediaTypes.upnp.id), listScroll, {focusIndex: focusIndex});
                    }
                });
            } else {
                upnp.openContext(breadcrumbs.head.parentID, function ( error, result ) {
                    if ( !error ) {
                        if ( result.length < focusIndex ) {
                            focusIndex = 0;
                        }

                        renderList(constructDataOut(result, mediaTypes.upnp.id), listScroll, {focusIndex: focusIndex});
                    }
                });
            }

            breadcrumbs.pop();
        }
    } else if ( breadcrumbs.config.type === mediaTypes.nfsServer ) {
        renderRoot();
    } else if ( breadcrumbs.config.type === mediaTypes.nfsShare ) {
        if ( app.runtime.stillWaitNetworkResponse ) {
            return;
        }

        app.runtime.stillWaitNetworkResponse = true;
        folderListView = null;
        nfsTraverse('getServers', breadcrumbs.head.path, {icon: 'theme-icon-server', index: focusIndex});
    }

    if ( breadcrumbs.length || breadcrumbs.config.type ) {
        searchAtCurrentOutput();
    }
}


/**
 * Connect network share with given parameters.
 *
 * @param {number} shareType - type of share to connect
 * @param {Object} mountInputs - parameters for connect
 * @param {Function} callback - method to invoke with a result of operation
 */
function manualNetShareConnect ( shareType, mountInputs, callback ) {
    var address, name, displayName, itemToAdd, server, config, index, sharesCount;


    function isSame () {
        app.runtime.stillWaitNetworkResponse = false;
        echo({
            title: gettext('The folder is already connected'),
            icon: 'alert',
            type: 'warning'
        });
    }


    if ( shareType === mediaTypes.nfsPermanentShare ) {
        if ( !mountInputs.address || !mountInputs.name ) {
            echo({
                title: gettext('Wrong connection parameters'),
                icon: 'alert',
                type: 'warning'
            });
            app.runtime.stillWaitNetworkResponse = false;

            return;
        }

        itemToAdd = {
            name: mountInputs.name,
            path: mountInputs.address + ':' + mountInputs.name
        };

        if ( mountInputs.displayName !== mountInputs.name ) {
            itemToAdd.displayName = mountInputs.displayName;
        }

        // prevent multiple additions of identical shares
        for ( index = 0, sharesCount = app.storage.network.nfs.length; index < sharesCount; index += 1 ) {
            if ( app.storage.network.nfs[index].path === itemToAdd.path ) {
                isSame();

                return;
            }
        }

        nfsTraverse('openShare', {path: itemToAdd.path}, {}, function ( error ) {
            if ( error ) {
                callback({message: gettext('Unable to connect to the resource with these parameters')});
            } else {
                callback(null);
                app.storage.network.nfs.push(itemToAdd);
                breadcrumbs.emit('reset');
                breadcrumbs.config.type = mediaTypes.folder.id;
                breadcrumbs.config.currentDevice = itemToAdd;
                breadcrumbs.config.currentDeviceType = mediaTypes.nfsPermanentShare;
                breadcrumbs.config.entryPointIndex = renderFilesListInitial.itemsLength;
                mainPanelTitle.innerText = itemToAdd.displayName || itemToAdd.name;
                mainPanel.focus();
            }
        });
    } else {
        if ( !mountInputs.address || !mountInputs.name ) {
            echo({
                title: gettext('Wrong connection parameters'),
                icon: 'alert',
                type: 'warning'
            });
            app.runtime.stillWaitNetworkResponse = false;

            return;
        }

        name = mountInputs.name;
        displayName = mountInputs.displayName;
        address = (mountInputs.address + '/' + name).split('/').filter(Boolean);
        server = address[0];
        name = address[1];
        config = {
            addresses: [server],
            folder: name,
            mountPath: app.config.mountPathSMB
        };
        itemToAdd = {
            name: config.folder,
            addresses: config.addresses
        };

        if ( mountInputs.login ) {
            itemToAdd.login = config.login = mountInputs.login;
            itemToAdd.password = config.password = mountInputs.password;
        }

        if ( displayName !== name ) {
            itemToAdd.displayName = displayName;
        }

        // prevent multiple additions of identical shares
        for ( index = 0, sharesCount = app.storage.network.smb.length; index < sharesCount; index += 1 ) {
            if ( JSON.stringify(app.storage.network.smb[index].addresses) === JSON.stringify(itemToAdd.addresses) && app.storage.network.smb[index].name === itemToAdd.name ) {
                isSame();

                return;
            }
        }

        breadcrumbs.config.currentDeviceType = 5;
        smbTraverse('openShare', config, {}, function ( error ) {
            if ( error ) {
                breadcrumbs.config.currentDeviceType = undefined;
                callback({message: gettext('Unable to connect to the resource with these parameters')});
            } else {
                callback(null);
                app.storage.network.smb.push(itemToAdd);
                breadcrumbs.config.isDisplaySmbShares = true;
                breadcrumbs.config.type = 1;
                breadcrumbs.config.currentDevice = itemToAdd;
                breadcrumbs.config.entryPointIndex = renderFilesListInitial.itemsLength;
                mainPanelTitle.innerText = itemToAdd.displayName || itemToAdd.name;
                mainPanel.focus();
            }
        });
    }
}


['connectSMB', 'connectNFS'].forEach(function ( event ) {
    app.addListener(event, function ( data ) {
        manualNetShareConnect(data.shareType, data.info, data.callback);
    });
});

page.addListeners({
    show: function () {
        if ( !page.loaded ) {
            ufsJson.load(function ( state, data ) {
                if ( data ) {
                    if ( Array.isArray(data.favoritesStorage) ) {
                        app.storage.favoritesStorage = data.favoritesStorage;
                    }

                    if ( Array.isArray(data.sharesStorage) ) {
                        app.storage.network.smb = data.sharesStorage;
                    } else if ( data.network ) {
                        if ( Array.isArray(data.network.smb) ) {
                            app.storage.network.smb = data.network.smb;
                        }

                        if ( Array.isArray(data.network.nfs) ) {
                            app.storage.network.nfs = data.network.nfs;
                        }
                    }

                    if ( app.storage.network.smb.length ) {
                        app.storage.network.smb.forEach(function ( share ) {
                            serversFavShares.push(share.server);
                        });
                    }
                }
            });

            renderPage([]);
            page.loaded = true;
        }
    },
    keydown: function ( event ) {
        if ( event.code === keys.back ) {
            if (
                mainPanel.$node.classList.contains('active') &&
                (breadcrumbs.length || breadcrumbs.config.isDisplayFavorites || breadcrumbs.config.type === mediaTypes.upnp.id)
            ) {
                goBack();
            } else if ( app.runtime.isModalShown ) {
                closeModalWindow();
            } else {
                ufsJson.saveSync(app.storage);
                appExit.goBack();
            }
        }
    }
});

core.addListeners({
    intent: function ( intent, callback ) {
        if ( intent.action === 'explorer:openResource' ) {
            if ( intent.data.resource ) {
                mediaTypes[
                    Object.keys(mediaTypes).filter(function ( key ) {
                        return mediaTypes[key].id === intent.data.resource;
                    })
                ].opener();
            } else if ( intent.data.serialNumber ) {
                storages[intent.data.serialNumber].opener();
            }
        }

        callback();
    },
    show: function () {
        if ( page.loaded ) {
            if ( UPnPMode !== app.environment.UPnPMode ) {
                UPnPMode = app.environment.UPnPMode;
                echo({
                    title: gettext('UPnP service status changed to') + ': ' + (UPnPMode === 'off' ? gettext('OFF') : UPnPMode.toUpperCase()),
                    icon: 'info'
                });
            }

            if ( breadcrumbs.config.currentDeviceType === mediaTypes.upnp.id && UPnPMode === 'off' ) {
                breadcrumbs.config.stageType = mediaTypes.upnpServer;
                breadcrumbs.config.entryPointIndex -= 1;
                goBack();
            } else if ( !breadcrumbs.config.type && ((UPnPMode === 'off') !== (app.environment.UPnPMode === 'off')) ) {
                renderList(
                    renderFilesListInitial(),
                    listScroll,
                    {focusIndex: mainPanelList.data[mainPanelList.$focusItem.index + 1] ? mainPanelList.$focusItem.index : mainPanelList.$focusItem.index - 1}
                );
            }
        }
    },
    exit: function () {
        ufsJson.saveSync(app.storage);
    }
});


module.exports = page;
